(function(){
  var root = document.querySelector('[data-ar-bespoke]');
  if(!root || root.dataset.bound) return;
  root.dataset.bound = '1';

  // Inquiry proxy endpoint (Cloudflare Worker). When set, submit POSTs the build here
  // (creates a draft order + branded email). When blank, falls back to the Shopify contact form.
  var INQUIRY_ENDPOINT = (window.AR_BW_CFG||{}).inquiryEndpoint || '';
  var SUCCESS_TITLE = (window.AR_BW_CFG||{}).successTitle || '';
  var SUCCESS_BODY = (window.AR_BW_CFG||{}).successBody || '';

  var cardOff = false, ready = false;
  function updateFloat(){ var f=document.getElementById('bw-float'); if(!f) return; var show=cardOff&&ready; f.classList.toggle('is-visible', show); f.setAttribute('aria-hidden', show?'false':'true'); }
  // progressive reveal — show each step only once its prerequisite is chosen
  function updateReveal(){
    var g=document.getElementById.bind(document);
    function show(id,on){ var e=g(id); if(e) e.classList.toggle('ar-bw__field--hidden', !on); }
    var c=g('bw-construction').value, s=g('bw-series').value, m=g('bw-model').value;
    var fd=g('bw-fd').value, fw=g('bw-fw').value;
    var s0=curSeries(), modMode=modularMode(), blMode=isBeadlock(), isTruck=(c==='truck');
    // lug pattern (truck only) — gates the series list
    show('bw-lugfield', isTruck);
    if(!isTruck && g('bw-lug').value){ g('bw-lug').value=''; refreshVS(g('bw-lug')); }
    show('bw-seriesfield', isTruck ? !!g('bw-lug').value : !!c);
    show('bw-modelfield', !!s);
    // beadlock fitment field — dedicated beadlock construction only (truck RD-BL is always full set)
    var showBlFit = (c==='bl') && !!m;
    show('bw-blfitfield', showBlFit);
    if(!showBlFit && g('bw-blfit').value){ g('bw-blfit').value=''; refreshVS(g('bw-blfit')); }
    show('bw-sizingblock', !!m);
    show('bw-finishblock', !!(fd && fw));
    // center finish label
    var clbl=g('bw-center-label'); if(clbl) clbl.textContent = modMode ? 'Center finish' : 'Wheel finish';
    // lip / barrel finish — modular-mode only
    show('bw-lipfield', modMode);
    if(!modMode && g('bw-lip').value){ g('bw-lip').value=''; refreshVS(g('bw-lip')); }
    // beadlock finish — beadlock-mode only (bl construction OR truck RD-BL)
    show('bw-blfinishfield', blMode);
    if(!blMode && g('bw-blfinish').value){ g('bw-blfinish').value=''; refreshVS(g('bw-blfinish')); }
    // lip style (Step / Flat) — modular-mode series flagged lipStyle (DF/LE-MLE/MHE/MHK)
    var showLipStyle = modMode && !!(s0 && s0.lipStyle);
    show('bw-lipstylerow', showLipStyle);
    if(!showLipStyle && g('bw-lipstyle').value){ g('bw-lipstyle').value=''; refreshVS(g('bw-lipstyle')); }
    // polished lip (modular-mode) — yes/no toggle + color reveal
    show('bw-polirow', modMode);
    show('bw-poliplipwantfield', modMode);
    if(!modMode && g('bw-poliplip-want').value){ g('bw-poliplip-want').value=''; refreshVS(g('bw-poliplip-want')); }
    var wantPoli = modMode && g('bw-poliplip-want').value==='yes';
    show('bw-poliplipfield', wantPoli);
    if(!wantPoli && g('bw-poliplip').value){ g('bw-poliplip').value=''; refreshVS(g('bw-poliplip')); }
    // assembly hardware — anything not monoblock
    show('bw-hardwarerow', showsHardware());
    // knurled bead seats are standard+free on beadlock-mode — hide the paid option
    show('bw-knurled-wrap', !blMode);
    if(blMode && g('bw-knurled').checked){ g('bw-knurled').checked=false; }
    // hardware style (Exposed / Hidden) — modular-mode EXCEPT hwHidden series (MHE, HCL)
    var showHwStyle = modMode && !(s0 && s0.hwHidden);
    show('bw-hwstylefield', showHwStyle);
    if(!showHwStyle && g('bw-hwstyle').value){ g('bw-hwstyle').value=''; refreshVS(g('bw-hwstyle')); }
    var lipLbl=g('bw-lip-label'); if(lipLbl) lipLbl.textContent = barrelOverride() ? 'Barrel finish' : 'Lip / barrel finish';
  }
  // OEM cap machining / center lock means the BC center cap doesn't apply
  function capExcluded(){ return document.getElementById('bw-oemcap').checked || document.getElementById('bw-oemlock').checked; }
  function con(){ return document.getElementById('bw-construction').value; }
  function isBlConstruction(){ return con()==='bl'; }   // dedicated beadlock construction: split image, "//", fitment field, -BL append
  // beadlock FEATURE = the bl construction OR a truck series flagged beadlock (RD-BL). Drives single wheel finish + beadlock finish + $250/wheel + stainless/black hardware + free knurled.
  function isBeadlock(){ var c=con(); return c==='bl' || (c==='truck' && !!(curSeries() && curSeries().beadlock)); }
  // modular-style fields (center + lip/barrel + hardware + style + polished + lip style): modular, or any non-beadlock truck series
  function modularMode(){ var c=con(); return c==='mod' || (c==='truck' && !isBeadlock()); }
  function blFitment(){ var s=document.getElementById('bw-blfit'); return s ? s.value : ''; }   // '' | 'frontstd' | 'full'
  function showsHardware(){ var c=con(); return c==='mod' || c==='truck' || c==='bl'; }   // anything not monoblock
  // human-readable construction name for the summary/recap
  function conLabel(){ var c=con(); return c==='truck' ? 'Truck' : (c==='mod' ? 'Modular' : (c==='bl' ? 'Beadlock' : (c==='mono' ? 'Monoblock' : ''))); }
  // the BC center cap is replaced by whichever OEM option they picked (the two are mutually exclusive)
  function capExcludedLabel(){ return document.getElementById('bw-oemcap').checked ? 'OEM Machined' : (document.getElementById('bw-oemlock').checked ? 'OEM Center Lock' : ''); }

  // ---- pricing tables (per wheel, width <= 11.0) ----
  // TABLES = MAP (our price, shown). MSRP = compare-at (struck through).
  var TABLES = {
    mono_std: {15:650,17:775,18:825,19:875,20:925,21:975,22:1025,23:1100,24:1350},
    mono_acl: {18:925,19:975,20:1025,21:1075,22:1125,23:1200,24:1450},
    mono_kx:  {19:1075,20:1125,21:1175,22:1225},
    mod_std:  {17:875,18:975,19:1050,20:1125,21:1250,22:1300,23:1425},
    mod_hcx:  {19:1250,20:1325,21:1450,22:1500}
  };
  var MSRP = {
    mono_std: {15:700,17:825,18:875,19:925,20:975,21:1025,22:1075,23:1150,24:1400},
    mono_acl: {18:975,19:1025,20:1075,21:1125,22:1175,23:1250,24:1500},
    mono_kx:  {19:1125,20:1175,21:1225,22:1275},
    mod_std:  {17:925,18:1025,19:1100,20:1175,21:1300,22:1350,23:1475},
    mod_hcx:  {19:1300,20:1375,21:1500,22:1550}
  };
  var WIDE_STEP = 50;      // width >= 11.5 in
  var BEADLOCK = 250;      // RD-BL retail per wheel
  var SHIP = { us:{small:350,large:400} }; // contiguous US; small=15-20, large=21-24

  // ---- catalog: series -> table, diameter range, models ----
  var CAT = {
    bl: [
      {k:'RD',  t:'mono_std', d:[17,20], m:['RD01','RD02','RD03','RD05','RD06','RD07']}
    ],
    // Truck = two-piece fastened modular, gated by lug pattern (per bcforged-na.com/trucks).
    // dlist = discrete diameters (truck sizes are not contiguous). Pricing uses each design's base table.
    truck: [
      {k:'LE-T', t:'mod_std', lugs:['8'], dlist:[20,22], m:['LE-T 808','LE-T 816','LE-T 832']},
      {k:'LE/MLE', t:'mod_std', lugs:['6'], dlist:[18,20,22], lipStyle:true, m:['LE05 / MLE05','LE10 / MLE10','LE20 / MLE20','LE210 / MLE210','LE215 / MLE215','LE52 / MLE52','LE61 / MLE61','LE65 / MLE65','LE72 / MLE72','LE81 / MLE81','LE82 / MLE82','LE83 / MLE83','LE90 / MLE90','LE91 / MLE91','LE92 / MLE92','LE93 / MLE93','LE96 / MLE96']},
      {k:'MHE', t:'mod_std', lugs:['6'], dlist:[20,22], lipStyle:true, hwHidden:true, m:['MHE11','MHE25','MHE28']},
      {k:'MHK', t:'mod_std', lugs:['6'], dlist:[20,22], lipStyle:true, m:['MHK510','MHK519','MHK525','MHK528']},
      {k:'RD-BL', t:'mono_std', lugs:['6'], dlist:[20,22], beadlock:true, m:['RD01-BL','RD03-BL','RD05-BL','RD06-BL','RD07-BL']},
      {k:'TPX', t:'mono_std', lugs:['6'], dlist:[20,22], m:['TPX61','TPX62','TPX63','TPX64','TPX65']},
      {k:'TD',  t:'mono_std', lugs:['6'], dlist:[20,22], dcLip:true, m:['TD01','TD02','TD03','TD05','TD06','TD07','TD16']},
      {k:'TH',  t:'mono_std', lugs:['6'], dlist:[20,22], dcLip:true, m:['TH03','TH06','TH09']},
      {k:'HW',  t:'mono_std', lugs:['6'], dlist:[20,22], m:['HW16','HW26','HW56']}
    ],
    mono: [
      {k:'RD',  t:'mono_std', d:[17,20], m:['RD01','RD02','RD03','RD05','RD06','RD07']},
      {k:'AE',  t:'mono_std', d:[17,22], m:['AE05','AE12']},
      {k:'AF',  t:'mono_std', d:[18,24], m:['AF18','AF55','AF616']},
      {k:'TD',  t:'mono_std', d:[17,22], m:['TD01','TD02','TD03','TD05','TD06','TD07','TD09','TD16'], dcLip:true},
      {k:'TR',  t:'mono_std', d:[17,22], m:['TR01','TR02','TR03','TR05','TR06','TR07']},
      {k:'TH',  t:'mono_std', d:[17,22], m:['TH03','TH06','TH09'], dcLip:true},
      {k:'BCR', t:'mono_std', d:[17,20], m:['BCR S5','BCR S6','BCR S7','BCR S10']},
      {k:'TPX', t:'mono_std', d:[18,22], m:['TPX51','TPX61','TPX62','TPX63','TPX64','TPX65']},
      {k:'ACL', t:'mono_acl', d:[18,24], m:['ACL01','ACL02','ACL05','ACL07','ACL09','ACL10','ACL15','ACL51']},
      {k:'KL',  t:'mono_std', d:[18,24], m:['KL01','KL02','KL11','KL12','KL13','KL14','KL17','KL18','KL23','KL31','KL32','KL34','KL47','KL51','KL52','KL53','KL54','KL55']},
      {k:'KZ',  t:'mono_std', d:[17,24], m:['KZ05','KZ06','KZ10','KZ15']},
      {k:'KX',  t:'mono_kx',  d:[19,22], m:['KX01','KX02','KX03','KX04','KX05','KX06','KX08','KX09']},
      {k:'EH',  t:'mono_std', d:[18,24], m:['EH28','EH99','EH168','EH171','EH172','EH173','EH175','EH176','EH181','EH182','EH183','EH184','EH185','EH186','EH188','EH189','EH201','EH211','EH231','EH301','EH307','EH308','EH309','EH351','EH353','EH361','EH511','EH671','EH672','EH673','EH674','EH675']},
      {k:'EH-T',t:'mono_std', d:[18,24], m:['EH-T01','EH-T02','EH-T03','EH-T04']},
      {k:'RZ',  t:'mono_std', d:[17,24], m:['RZ01','RZ02','RZ05','RZ053','RZ10','RZ15','RZ20','RZ21','RZ22','RZ23','RZ24','RZ25','RZ35','RZ39','RZ815']},
      {k:'RS',  t:'mono_std', d:[15,24], m:['RS31','RS40','RS41','RS42','RS43','RS45']},
      {k:'MKP', t:'mono_std', d:[20,24], m:['MKP25','MKP30','MKP45']},
      {k:'RT',  t:'mono_std', d:[17,24], m:['RT50','RT51','RT52','RT53']},
      {k:'GW',  t:'mono_std', d:[18,24], m:['GW01','GW02','GW03','GW06','GW19','GW29','GWA02','GWA03','GWA05']},
      {k:'HW',  t:'mono_std', d:[18,23], m:['HW16','HW26','HW56']}
    ],
    mod: [
      {k:'HCA', t:'mod_std', d:[18,23], m:['HCA062','HCA063','HCA161','HCA162','HCA163','HCA165','HCA167','HCA168','HCA191','HCA192','HCA193','HCA195','HCA196','HCA197','HCA198','HCA199','HCA210','HCA214','HCA215','HCA217','HCA218','HCA221','HCA222','HCA381','HCA382','HCA383','HCA384','HCA385','HCA386','HCA388','HCA389','HCA510','HCA671','HCA674','HCA675','HCA811','HCA812','HCA813']},
      {k:'HCS', t:'mod_std', d:[18,23], m:['HCS01','HCS02','HCS03','HCS04','HCS08','HCS15','HCS151','HCS21','HCS23','HCS24','HCS31','HCS32','HCS33','HCS34','HCS35','HCS37','HCS71','HCS72','HCS75','HCS855']},
      {k:'HC',  t:'mod_std', d:[18,23], m:['HC010','HC012','HC027','HC029','HC033','HC040','HC050','HC052','HC053','HC055','HC056']},
      {k:'HCL', t:'mod_std', d:[18,23], hwHidden:true, m:['HCL10','HCL20']},
      {k:'HCK', t:'mod_std', d:[19,23], m:['HCK04','HCK165','HCK196','HCK198','HCK21','HCK381','HCK386','HCK675','HCK855']},
      {k:'HCX', t:'mod_hcx', d:[19,22], m:['HCX01','HCX02','HCX05','HCX06','HCX08','HCX108']},
      {k:'LE/MLE', t:'mod_std', d:[17,23], lipStyle:true, m:['LE05 / MLE05','LE10 / MLE10','LE20 / MLE20','LE31 / MLE31','LE51 / MLE51','LE52 / MLE52','LE53 / MLE53','LE61 / MLE61','LE65 / MLE65','LE72 / MLE72','LE81 / MLE81','LE82 / MLE82','LE83 / MLE83','LE90 / MLE90','LE91 / MLE91','LE92 / MLE92','LE93 / MLE93','LE96 / MLE96','LE210 / MLE210','LE215 / MLE215','LE910 / MLE910']},
      {k:'MHE', t:'mod_std', d:[18,23], lipStyle:true, hwHidden:true, m:['MHE11','MHE25','MHE28','MHE31','MHE910']},
      {k:'MHK', t:'mod_std', d:[19,23], lipStyle:true, m:['MHK510','MHK519','MHK525','MHK528']},
      {k:'DF',  t:'mod_std', d:[17,22], lipStyle:true, m:['DF-R1','DF-Z1']},
      {k:'HB',  t:'mod_std', d:[18,23], m:['HB04','HB36']}
    ]
  };

  // ---- image assets (BC Forged calculator swatches hosted on this theme) ----
  var ASSET_BASE = (window.AR_BW_CFG||{}).assetBase || '';
  // Cache-bust: model URLs are built in JS so they DON'T inherit Shopify's per-file ?v= — without a
  // version query the Shopify CDN pins the bare path to whatever was first cached (an updated photo
  // would keep showing the OLD image). Bump ASSET_VER whenever any bcw-*/bcf-*/bch-*/bcv-*/bcc-* photo
  // is changed/replaced so every built URL becomes a cache miss and re-pulls fresh from origin.
  var ASSET_VER = '20260615b';
  function imgUrl(file){ return ASSET_BASE + file + '?v=' + ASSET_VER; }
  // model design thumbnails available (by normalized code)
  var MODELS_AVAIL = {};
  ('acl01 acl02 acl05 acl07 acl09 acl10 acl15 acl51 ae05 ae12 af18 af55 af616 bcrs10 bcrs5 bcrs6 bcrs7 dfr1 dfz1 eh168 eh171 eh172 eh173 eh175 eh176 eh181 eh182 eh183 eh184 eh185 eh186 eh188 eh189 eh201 eh211 eh231 eh28 eh301 eh307 eh308 eh309 eh351 eh353 eh361 eh511 eh671 eh672 eh673 eh674 eh675 eh99 eht01 eht02 eht03 eht04 gw01 gw02 gw03 gw06 gw19 gw29 gwa02 gwa03 gwa05 hb04 hb36 hc010 hc012 hc027 hc029 hc033 hc040 hc050 hc052 hc053 hc055 hc056 hca062 hca063 hca161 hca162 hca163 hca165 hca167 hca168 hca191 hca192 hca193 hca195 hca196 hca197 hca198 hca199 hca210 hca214 hca215 hca217 hca218 hca221 hca222 hca381 hca382 hca383 hca384 hca385 hca386 hca388 hca389 hca510 hca671 hca674 hca675 hca811 hca812 hca813 hck04 hck165 hck196 hck198 hck21 hck381 hck386 hck675 hck855 hcl10 hcl20 hcs01 hcs02 hcs03 hcs04 hcs08 hcs15 hcs151 hcs21 hcs23 hcs24 hcs31 hcs32 hcs33 hcs34 hcs35 hcs37 hcs71 hcs72 hcs75 hcs855 hcx01 hcx02 hcx05 hcx06 hcx08 hcx108 hw16 hw26 hw56 kl01 kl02 kl11 kl12 kl13 kl14 kl17 kl18 kl23 kl31 kl32 kl34 kl47 kl51 kl52 kl53 kl54 kl55 kx01 kx02 kx03 kx04 kx05 kx06 kx08 kx09 kz05 kz06 kz10 kz15 le05 le10 le20 le210 le215 le31mle31 le51 le52 le53 le61 le65 le72 le81 le82 le83mle83 le90 le910mle910 le91mle91 le92 le93 le96 let808 let816 let832 mhe11 mhe25 mhe28 mhe31 mhe910 mhk510 mhk519 mhk525 mhk528 mkp25 mkp30 mkp45 rd01 rd01bl rd02 rd02bl rd03 rd03bl rd05 rd05bl rd06 rd06bl rd07 rd07bl rs31 rs40 rs41 rs42 rs43 rs45 rt50 rt51 rt52 rt53 rz01 rz02 rz05 rz053 rz10 rz15 rz20 rz21 rz22 rz23 rz24 rz25 rz35 rz39 rz815 td01 td02 td03 td05 td06 td07 td09 td16 th03 th06 th09 tpx51 tpx61 tpx62 tpx63 tpx64 tpx65 tr01 tr02 tr03 tr05 tr06 tr07').split(' ').forEach(function(c){ MODELS_AVAIL[c]=1; });
  var MODEL_ALIAS = { gwa02:'gw02a', kx06:'kx6', hc029:'hc029s' };
  function modelImg(val){
    if(!val) return '';
    var full = val.toLowerCase().replace(/[^a-z0-9]/g,'');
    var cands = [full].concat(val.split(/[^a-z0-9]+/i).map(function(t){return t.toLowerCase();}));
    if(MODEL_ALIAS[full]) cands.push(MODEL_ALIAS[full]);
    for(var i=0;i<cands.length;i++){ if(cands[i] && MODELS_AVAIL[cands[i]]) return imgUrl('bcw-'+cands[i]+'.webp'); }
    return '';
  }

  // ---- live "build at a glance" thumbnails in the price card ----
  // reads the currently-selected <option>'s photo (data-img) for each visual picker.
  function selImg(id){
    var s=$(id); if(!s||!s.value) return null;
    var o=s.options[s.selectedIndex]; if(!o||!o.value) return null;
    return { img:(o.dataset&&o.dataset.img)||'', label:o.value };
  }
  function specEsc(str){ return String(str==null?'':str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function renderSpecPics(){
    var box=$('bw-specpics'); if(!box) return;
    var modMode=modularMode();
    var items=[]; // [label, {img,label}, isSwatch]
    var m=selImg('bw-model'); if(m){ if(isBlConstruction()) m.label=modelLabel(); items.push(['Model', m, false]); }
    var cf=selImg('bw-center'); if(cf) items.push([modMode?'Center':(isBeadlock()?'Wheel':'Finish'), cf, true]);
    if(modMode){ var lf=selImg('bw-lip'); if(lf) items.push([barrelOverride()?'Barrel':'Lip', lf, true]); }
    if(isBeadlock()){ var blf=selImg('bw-blfinish'); if(blf) items.push(['Beadlock', blf, true]); }
    if(showsHardware()){ var hw=selImg('bw-hardware'); if(hw){ var hst=''; if(modMode){ var sc2=curSeries(); if(sc2&&sc2.hwHidden) hst='Hidden'; else if($('bw-hwstyle').value) hst=$('bw-hwstyle').value; } if(hst) hw.label=hw.label+' ('+hst+')'; items.push(['Hardware', hw, true]); } }
    if(!capExcluded()){ var cp=selImg('bw-cap'); if(cp) items.push(['Center cap', cp, true]); }
    var vv=selImg('bw-valve'); if(vv) items.push(['Valve', vv, true]);
    if(!items.length){ box.innerHTML=''; box.setAttribute('aria-hidden','true'); return; }
    box.setAttribute('aria-hidden','false');
    box.innerHTML = items.map(function(it){
      var label=it[0], d=it[1], sw=it[2];
      var bg = d.img ? ('background-image:url(\''+d.img+'\')') : '';
      var style = bg ? (' style="'+bg+'"') : ' data-empty';
      var popImg = bg ? (' style="'+bg+'"') : ' data-empty';
      return '<div class="ar-bw__specpic'+(sw?' ar-bw__specpic--swatch':'')+'">'+
        '<span class="ar-bw__specpic-img"'+style+'></span>'+
        '<span class="ar-bw__specpic-cap">'+label+'</span>'+
        '<div class="ar-bw__specpop" role="tooltip">'+
          '<span class="ar-bw__specpop-img"'+popImg+'></span>'+
          '<span class="ar-bw__specpop-cap">'+label+'</span>'+
          '<span class="ar-bw__specpop-val">'+specEsc(d.label)+'</span>'+
        '</div>'+
      '</div>';
    }).join('');
  }

  // ---- finishes (BC Forged swatches; value = label, image via slug) ----
  var FIN_NAMES = ['Gloss Bright Clear','Gloss Bright Graphite Grey','Gloss Brushed Clear','Gloss Brushed Grey','Gloss Brushed Graphite Grey','Gloss Brushed Dark Black','Gloss Brushed Bronze','Gloss Brushed Royal Gold','Gloss Brushed Gold','Gloss Brushed Sunset Copper','Gloss Brushed Champagne Bronze','Gloss Brushed Crystal Orange','Gloss Brushed Crystal Burgundy','Gloss Brushed Rose Gold','Gloss Brushed Crystal Dark Blue','Gloss Brushed Sapphire Blue','Gloss Brushed Crystal Purple','Gloss Brushed Crystal Green','Gloss Stone','Satin Brushed Clear','Satin Brushed Grey','Satin Brushed Graphite Grey','Satin Brushed Royal Gold','Satin Brushed Rose Gold','Satin Brushed Champagne Bronze','Satin Brushed Sunset Copper','Satin Brushed Crystal Purple','Satin Army Green','Satin Race Gold','Satin Obsidian Blue','Gloss Lunar Silver','Gloss Bronze','Gloss Gunmetal','Gloss Black','Gloss Obsidian Blue','Gloss White','Matte Bronze','Matte Golden Bronze','Matte Shadow Copper','Matte Gunmetal','Matte Black'];
  var FIN_SLUGS = ['bright-clear','bright-graphite-grey','brushed-clear','brushed-grey','graphite-grey','brushed-dark-black','brushed-bronze','royal-gold','brushed-gold','brushed-gloss-copper','brushed-cham-bronze','crystal-orange','crystal-burgundy','rose-gold','crystal-dark-blue','sapphire-blue','crystal-purple','crystal-green','stone','satin-brushed','satin-grey','satin-graphite-grey','satin-royal-gold','satin-rose-gold','brushed-satin-champange','brushed-satin-copper','satin-purple','satin-army-green','satin-gold','satin-obsidian-blue','lunar-silver','gloss-bronze','gloss-gunmetal','gloss-black','obsidian-blue','gloss-white','matte-bronze','matte-golden-bronze','shadow-copper','matte-gunmetal','matte-black'];
  var FIN_CENTER = FIN_NAMES.map(function(name,index){ return {value:name,img:imgUrl('bcf-'+FIN_SLUGS[index]+'.webp')}; });
  var FIN_LIP = FIN_CENTER.slice(2).concat([{value:'Polished w/ Clear Powder',img:imgUrl('bcf-polished.webp')}]);
  var POLISH_LIP = ['Polished Clear','Polished Grey (+$100/wheel)','Polished Bronze (+$100/wheel)','Polished Royal Gold (+$100/wheel)','Polished Champagne Bronze (+$100/wheel)','Polished Rose Gold (+$100/wheel)','Polished Crystal Burgundy (+$100/wheel)','Polished Sapphire Blue (+$100/wheel)','Polished Crystal Orange (+$100/wheel)'];

  function widthRange(minimum,maximum){
    var out=[]; for(var width=minimum;width<=maximum+0.001;width+=0.5) out.push(width.toFixed(1)); return out;
  }
  // Published orderable combinations from the BC Forged NA dealer matrix. The series catalog
  // above controls diameters; this layer prevents invalid widths and retains valid 13.5/14.0 sizes.
  var SIZE_MATRICES = {
    mono_primary:{15:['7.0','8.0','9.0','10.0'],17:widthRange(7,12),18:widthRange(8,13),19:widthRange(8,13),20:widthRange(8,13),21:widthRange(8,13),22:widthRange(8.5,12.5),23:widthRange(9,12),24:widthRange(10,12.5)},
    mono_secondary:{17:widthRange(7,12),18:widthRange(8,13),19:widthRange(8,13),20:widthRange(8,13),21:widthRange(8,13),22:widthRange(8.5,12.5),23:widthRange(9.5,12),24:widthRange(10,12.5)},
    mono_acl:{18:widthRange(8,13),19:widthRange(8,13),20:widthRange(8,13),21:widthRange(8.5,13),22:widthRange(8.5,13),23:widthRange(9.5,12),24:widthRange(10,12.5)},
    mono_kx:{19:widthRange(8,13),20:widthRange(8,13),21:widthRange(8,13),22:widthRange(8.5,12.5)},
    mod_primary:{18:widthRange(8,13),19:widthRange(8,13),20:widthRange(8,14),21:widthRange(8,14),22:widthRange(8,14),23:widthRange(9.5,13)},
    mod_secondary:{17:widthRange(7,12.5),18:widthRange(8,13),19:widthRange(8,13),20:widthRange(8,13),21:widthRange(8,14),22:widthRange(8.5,14),23:widthRange(9,12).concat(['13.0'])},
    mod_hcx:{19:widthRange(8,13),20:widthRange(8,14),21:widthRange(8,14),22:widthRange(8.5,14)}
  };
  function sizeMatrixKey(s){
    if(s.t==='mono_acl'||s.t==='mono_kx'||s.t==='mod_hcx') return s.t;
    if(s.t==='mod_std') return ['HC','HCA','HCK','HCL','HCS','HB'].indexOf(s.k)>=0?'mod_primary':'mod_secondary';
    return ['BCR','GW','HW','KL','KZ','RD','RS','RT','RZ'].indexOf(s.k)>=0?'mono_primary':'mono_secondary';
  }
  function widthsForSeries(s,diameter){
    if(!s||!diameter) return [];
    var widths=(SIZE_MATRICES[sizeMatrixKey(s)][diameter]||[]).slice();
    var five=(diameter===18&&['RD','RS','RT','RZ'].indexOf(s.k)>=0)||
      ([19,20].indexOf(diameter)>=0&&['GW','HW','KL','KZ','RD','RS','RT','RZ'].indexOf(s.k)>=0);
    if(five) widths.unshift('5.0');
    return widths;
  }

  // ---- helpers ----
  function $(id){ return document.getElementById(id); }
  function opt(sel, val, label, img){ var o=document.createElement('option'); o.value=val; o.textContent=label||val; if(img)o.dataset.img=img; sel.appendChild(o); }
  function ph(sel, text){ var o=document.createElement('option'); o.value=''; o.textContent=text; o.selected=true; sel.appendChild(o); }
  function money(n){ return '$' + Math.round(n).toLocaleString('en-US'); }
  function diamsFor(s){ var t=TABLES[s.t], out=[]; if(s.dlist){ s.dlist.forEach(function(d){ if(t[d]!=null) out.push(d); }); return out; } for(var d=s.d[0]; d<=s.d[1]; d++){ if(t[d]!=null) out.push(d); } return out; }
  function curSeries(){ var c=$('bw-construction').value; if(!c) return null; var list=CAT[c]||[], k=$('bw-series').value; for(var i=0;i<list.length;i++){ if(list[i].k===k) return list[i]; } return null; }

  // ---- populate selects (no preselected defaults — customer must choose) ----
  function fillSeries(){
    var c=$('bw-construction').value, sel=$('bw-series'); sel.innerHTML='';
    if(!c){ ph(sel,'Select construction first'); }
    else if(c==='truck' && !$('bw-lug').value){ ph(sel,'Select lug pattern first'); }
    else {
      ph(sel,'Select series…');
      var list = CAT[c]||[];
      if(c==='truck'){ var lug=$('bw-lug').value; list = list.filter(function(s){ return (s.lugs||[]).indexOf(lug)>=0; }); }
      list.forEach(function(s){ opt(sel, s.k, s.k + ' Series'); });
    }
    refreshVS(sel);
    fillModels(); fillFinish();
  }
  function fillModels(){
    var s=curSeries(), sel=$('bw-model'), bl=isBlConstruction(); sel.innerHTML='';
    if(!s){ ph(sel,'Select series first'); $('bw-model-count').textContent=''; }
    else { ph(sel,'Select model…'); s.m.forEach(function(m){
        // dedicated beadlock construction shows "RD02 // RD02-BL" with a split image (left std, right beadlock)
        var label = bl ? (m+' // '+m+'-BL') : m;
        var img = bl ? imgUrl('bcw-'+m.toLowerCase()+'-split.webp') : modelImg(m);
        opt(sel,m,label,img);
      }); $('bw-model-count').textContent='('+s.m.length+' designs)'; }
    refreshVS(sel);
    fillDiameters();
  }
  // display name of the chosen model — beadlock construction shows the standard // beadlock pair
  function modelLabel(){ var v=$('bw-model').value; if(!v) return ''; return isBlConstruction() ? (v+' // '+v+'-BL') : v; }
  function fillDiameters(){
    var s=curSeries(), ds=s?diamsFor(s):[];
    ['bw-fd','bw-rd'].forEach(function(id){ var sel=$(id); sel.innerHTML=''; ph(sel,'Diameter'); ds.forEach(function(d){ opt(sel,d,d+'"'); }); refreshVS(sel); });
    fillWidths();
  }
  function fillWidths(){
    var s=curSeries();
    [['bw-fw','bw-fd'],['bw-rw','bw-rd']].forEach(function(ids){
      var sel=$(ids[0]), diameter=parseInt($(ids[1]).value,10), previous=sel.value; sel.innerHTML=''; ph(sel,'Width');
      widthsForSeries(s,diameter).forEach(function(width){ opt(sel,width,width+'"'); });
      if([].some.call(sel.options,function(option){ return option.value===previous; })) sel.value=previous;
      refreshVS(sel);
    });
  }
  // populate the finish selects (visibility is handled centrally by updateReveal). center/lip/beadlock
  // finishes all use FIN_ALL (series-independent), so populate them for any finish-bearing construction.
  function fillFinish(){
    var c=$('bw-construction').value;
    var center=$('bw-center'); center.innerHTML='';
    ph(center, c?'Select finish…':'Select construction first'); if(c){ FIN_CENTER.forEach(function(f){ opt(center,f.value,f.value,f.img); }); }
    if(c==='mod'||c==='truck'||c==='bl'){
      var lip=$('bw-lip'); lip.innerHTML=''; ph(lip,'Select lip finish…'); FIN_LIP.forEach(function(f){ opt(lip,f.value,f.value,f.img); });
      var pl=$('bw-poliplip'); pl.innerHTML=''; ph(pl,'Select polished lip color…'); POLISH_LIP.forEach(function(f){ opt(pl,f); });
      var blf=$('bw-blfinish'); blf.innerHTML=''; ph(blf,'Select beadlock finish…'); FIN_CENTER.forEach(function(f){ opt(blf,f.value,f.value,f.img); });
    }
    $('bw-poliplip-want').value='';
    refreshVS($('bw-center')); refreshVS($('bw-lip')); refreshVS($('bw-poliplip')); refreshVS($('bw-blfinish')); refreshVS($('bw-poliplip-want'));
  }
  // assembly hardware finishes — modular offers all four; beadlock lock-ring hardware is stainless or black only
  var hwBuiltBeadlock = null;
  function fillHardware(){
    var bl = isBeadlock();
    if(bl === hwBuiltBeadlock) return; // only rebuild when the mode actually changes
    hwBuiltBeadlock = bl;
    var sel=$('bw-hardware'), cur=sel.value; sel.innerHTML='';
    ph(sel,'Select hardware…');
    opt(sel,'Stainless Steel','Stainless Steel',imgUrl('bch-stainless.webp'));
    opt(sel,'Black','Black',imgUrl('bch-black.webp'));
    if(!bl){ opt(sel,'Gold','Gold',imgUrl('bch-gold.webp')); opt(sel,'Titanium','Titanium',imgUrl('bch-titanium.webp')); }
    if([].some.call(sel.options, function(o){ return o.value===cur; })) sel.value=cur;
    refreshVS(sel);
  }
  function syncDiamondCut(){
    var s=curSeries(), dcLip = !!(s && s.dcLip);
    // diamond-cut FACE = all series except TD/TH ; diamond-cut LIP = TD/TH only
    $('bw-dcface-wrap').classList.toggle('ar-bw__field--hidden', dcLip);
    if(dcLip){ $('bw-dcface').checked=false; }
    $('bw-dclip-wrap').classList.toggle('ar-bw__field--hidden', !dcLip);
    if(!dcLip){ $('bw-dclip').checked=false; }
    // each diamond-cut option needs a color once it's checked
    var faceOn = !dcLip && $('bw-dcface').checked;
    $('bw-dcface-colorwrap').classList.toggle('ar-bw__field--hidden', !faceOn);
    if(!faceOn && $('bw-dcface-color').value){ $('bw-dcface-color').value=''; refreshVS($('bw-dcface-color')); }
    var lipOn = dcLip && $('bw-dclip').checked;
    $('bw-dclip-colorwrap').classList.toggle('ar-bw__field--hidden', !lipOn);
    if(!lipOn && $('bw-dclip-color').value){ $('bw-dclip-color').value=''; refreshVS($('bw-dclip-color')); }
  }
  // a polished lip or diamond-cut lip overrides the lip distinction, so the lip/barrel field becomes just "Barrel"
  function barrelOverride(){
    if(!modularMode()) return false;
    if($('bw-poliplip-want').value==='yes') return true;
    return !$('bw-dclip-wrap').classList.contains('ar-bw__field--hidden') && $('bw-dclip').checked;
  }

  // ---- pricing ----
  function perWheel(set, s, dia, width){
    var base = set[s.t][dia]; if(base==null) return 0;
    if(parseFloat(width) >= 11.5) base += WIDE_STEP;
    return base;
  }
  function calc(){
    var s=curSeries();
    var square=$('bw-square').checked;
    var fd=parseInt($('bw-fd').value,10), fw=$('bw-fw').value;
    var rd=square?fd:parseInt($('bw-rd').value,10), rw=square?fw:$('bw-rw').value;
    var isBL=isBeadlock();
    // bl construction uses the fitment toggle; truck RD-BL is always a full beadlock set
    var fit = isBlConstruction() ? blFitment() : (isBL ? 'full' : '');
    var complete = !!s && !isNaN(fd) && fw!=='' && (square || (!isNaN(rd) && rw!=='')) && (!isBL || !!fit);
    if(!complete) return {incomplete:true};
    // beadlock adder ($250/wheel retail): rear always beadlock; front beadlock only on a full set
    var frontBL = isBL && fit==='full', rearBL = isBL;
    var baseModel = $('bw-model').value;
    // only the dedicated bl construction appends "-BL" (truck RD-BL models already include it)
    var frontModel = (isBlConstruction() && frontBL) ? baseModel+'-BL' : baseModel;
    var rearModel  = (isBlConstruction() && rearBL)  ? baseModel+'-BL' : baseModel;
    // MAP = our price ; MSRP = compare-at
    var fEach=perWheel(TABLES,s,fd,fw)+(frontBL?BEADLOCK:0), rEach=perWheel(TABLES,s,rd,rw)+(rearBL?BEADLOCK:0);
    var fMsrp=perWheel(MSRP,s,fd,fw)+(frontBL?BEADLOCK:0),  rMsrp=perWheel(MSRP,s,rd,rw)+(rearBL?BEADLOCK:0);

    var total=0, msrp=0;
    // --- base wheel charges (key = "Front × 2", value = the size; beadlock prefixes the model variant) ---
    var baseLines=[];
    baseLines.push(['Front × 2', (isBL?frontModel+' · ':'')+fd+'×'+fw, fEach*2]); total+=fEach*2; msrp+=fMsrp*2;
    baseLines.push(['Rear × 2', (isBL?rearModel+' · ':'')+rd+'×'+rw, rEach*2]); total+=rEach*2; msrp+=rMsrp*2;

    // --- upcharges (each per-wheel option ×4) — identical adders on MAP & MSRP ---
    var upLines=[];
    function up(per, name){ var c=per*4; upLines.push([name+' × 4', c]); total+=c; msrp+=c; }
    if($('bw-knurled').checked) up(50,'Knurled bead seats');
    if($('bw-oemcap').checked) up(100,'OEM cap machining');
    if($('bw-oemlock').checked) up(100,'OEM center lock');
    if(!$('bw-dcface-wrap').classList.contains('ar-bw__field--hidden') && $('bw-dcface').checked) up(100,'Diamond-cut face'+($('bw-dcface-color').value?' — '+$('bw-dcface-color').value:''));
    if(!$('bw-dclip-wrap').classList.contains('ar-bw__field--hidden') && $('bw-dclip').checked) up(100,'Diamond-cut lip'+($('bw-dclip-color').value?' — '+$('bw-dclip-color').value:''));
    if(modularMode() && $('bw-poliplip-want').value==='yes' && $('bw-poliplip').value.indexOf('+$100')>=0){
      up(100, 'Polished lip — ' + $('bw-poliplip').value.replace(' (+$100/wheel)',''));
    }

    // staggered is NOT an upcharge — BC prices each axle per-wheel, so front×2 + rear×2 already
    // covers a staggered fitment ("any configuration, staggered or square, ordered normally").
    var stag = !square && (fd!==rd || fw!==rw);

    // shipping
    var maxD=Math.max(fd, rd);
    var ship=SHIP.us[maxD<=20?'small':'large'];
    var shipLine=['Shipping (contiguous US)', ship]; total+=ship; msrp+=ship;

    return {baseLines:baseLines, upLines:upLines, shipLine:shipLine, total:total, msrp:msrp, stag:stag, fEach:fEach, rEach:rEach, fMsrp:fMsrp, rMsrp:rMsrp, fd:fd, fw:fw, rd:rd, rw:rw, square:square, isBL:isBL, fit:fit, frontModel:frontModel, rearModel:rearModel};
  }

  function render(){
    syncDiamondCut();
    fillHardware();
    updateReveal();
    var capX = capExcluded();
    $('bw-capfield').classList.toggle('ar-bw__field--hidden', capX);
    if(capX){ $('bw-cap').classList.remove('is-invalid'); $('bw-cap').setAttribute('aria-invalid','false'); if(VS['bw-cap']){ VS['bw-cap'].trig.classList.remove('is-invalid'); VS['bw-cap'].trig.setAttribute('aria-invalid','false'); } }
    $('bw-rear-axle').style.display = $('bw-square').checked ? 'none' : '';
    renderSpecPics();
    var r=calc();
    if(r.incomplete){
      ready=false;
      $('bw-compare').textContent='';
      $('bw-total').textContent='$—';
      $('bw-save').textContent='';
      $('bw-headline').textContent='Choose construction, series, model & sizing to see pricing';
      $('bw-lines').innerHTML='';
      $('bw-stag-note').textContent='';
      $('bw-float-compare').textContent='';
      $('bw-float-total').textContent='$—';
      updateFloat();
      return;
    }
    ready=true;
    $('bw-compare').textContent = money(r.msrp);
    $('bw-total').textContent = money(r.total);
    $('bw-float-compare').textContent = money(r.msrp);
    $('bw-float-total').textContent = money(r.total);
    var save = r.msrp - r.total;
    $('bw-save').textContent = save>0 ? ('You save ' + money(save) + ' vs. MSRP') : '';
    var modelTxt = modelLabel() ? (' · ' + modelLabel()) : '';
    var conTxt = conLabel() ? (conLabel() + ' · ') : '';
    $('bw-headline').textContent = conTxt + curSeries().k + ' Series' + modelTxt;
    var ul=$('bw-lines'); ul.innerHTML='';
    function head(txt){ var li=document.createElement('li'); li.className='ar-bw__lines-head'; li.textContent=txt; ul.appendChild(li); }
    function line(label, val, cls){ var li=document.createElement('li'); if(cls)li.className=cls; li.innerHTML='<span>'+specEsc(label)+'</span><b>'+val+'</b>'; ul.appendChild(li); }

    function metaLine(key, val, rightHTML, cls){ var li=document.createElement('li'); if(cls)li.className=cls; li.innerHTML='<span class="ar-bw__lines-meta"><span class="ar-bw__lines-key">'+specEsc(key)+'</span><span class="ar-bw__lines-val">'+specEsc(val)+'</span></span><b>'+rightHTML+'</b>'; ul.appendChild(li); }

    // --- Base wheel charges: front/rear (key + size + price) + the included selections ---
    head('Base wheel charges');
    r.baseLines.forEach(function(l){ metaLine(l[0], l[1], money(l[2])); });
    includedItems().forEach(function(it){ metaLine(it[0], it[1], 'Included', 'is-included'); });

    // --- Upcharges (only when present) ---
    if(r.upLines.length){ head('Upcharges'); r.upLines.forEach(function(l){ line(l[0], money(l[1])); }); }

    // --- Shipping ---
    head('Shipping');
    line(r.shipLine[0], money(r.shipLine[1]));

    var tot=document.createElement('li'); tot.className='is-total'; tot.innerHTML='<span>Your price</span><b>'+money(r.total)+'</b>'; ul.appendChild(tot);
    var cmp=document.createElement('li'); cmp.className='is-compare'; cmp.innerHTML='<span>MSRP</span><b>'+money(r.msrp)+'</b>'; ul.appendChild(cmp);
    $('bw-stag-note').textContent = r.stag ? 'Includes true-staggered build (front & rear centers are spec-specific).' : '';
    updateFloat();
  }

  // included-at-no-charge selections, shown as aligned [key,value] line items under "Base wheel charges"
  function includedItems(){
    var modMode=modularMode();
    var out=[];
    if(isBeadlock() && blFitment()) out.push(['Beadlock', blFitment()==='full' ? 'Full set' : 'Standard front / Beadlock rear']);
    var cf=selImg('bw-center'); if(cf) out.push([modMode?'Center':'Finish', cf.label]);
    if(modMode){ var lf=selImg('bw-lip'); if(lf) out.push([barrelOverride()?'Barrel':'Lip / Barrel', lf.label]);
      var ls=$('bw-lipstyle'); if(ls && ls.value && !$('bw-lipstylerow').classList.contains('ar-bw__field--hidden')) out.push(['Lip Style', ls.value]);
      // free polished lip (Polished Clear) shows as included; paid colors appear under Upcharges
      if($('bw-poliplip-want').value==='yes'){ var pl=$('bw-poliplip'); if(pl && pl.value && pl.value.indexOf('+$100')<0) out.push(['Polished lip', pl.value]); } }
    if(isBeadlock()){
      var blf=selImg('bw-blfinish'); if(blf) out.push(['Beadlock finish', blf.label]);
      out.push(['Bead seats', 'Knurled (standard)']);
    }
    if(showsHardware()){ var hw=selImg('bw-hardware');
      if(hw){ var hwStyle=''; if(modMode){ var sc=curSeries(); if(sc && sc.hwHidden) hwStyle='Hidden'; else if($('bw-hwstyle').value) hwStyle=$('bw-hwstyle').value; }
        out.push(['Hardware', hw.label + (hwStyle ? (' ('+hwStyle+')') : '')]); } }
    if(capExcluded()) out.push(['Center cap', capExcludedLabel()]);
    else { var cp=$('bw-cap'); if(cp && cp.value) out.push(['Center cap', cp.value]); }
    var vv=selImg('bw-valve'); if(vv) out.push(['Valve stems', vv.label]);
    return out;
  }

  // ---- submit: pack hidden fields ----
  function pack(){
    var sus=document.querySelector('[name=bw_suspension]:checked'); var susV=sus?sus.value:'';
    if(susV==='Other'){ susV='Other — '+($('bw-vehicle')&&document.querySelector('[name=bw_suspension_other]').value||''); }
    var br=document.querySelector('[name=bw_brakes]:checked'); var brV=br?br.value:'';
    var brOther=document.querySelector('[name=bw_brakes_other]');
    if(brV.indexOf('Custom')===0 && brOther && brOther.value){ brV='Custom — '+brOther.value; }
    var r=calc();
    var modMode=modularMode();
    // finish + options come from the SHARED source functions, so the recap modal, the email, and the
    // contact-fallback all read identical formatting (multi-line, Lip/Barrel label, priced options).
    var finish = finishLines().map(function(x){ return x[0]+': '+x[1]; }).join('\n');
    var ol = optionLines();
    var optsFlat = ol.length ? ol.map(function(x){ return x[0]+(x[1]&&x[1]!=='Included'?(' — '+x[1]):''); }).join('\n') : 'None';

    $('hf-suspension').value=susV;
    $('hf-brakes').value=brV;
    var fitLabel = r.isBL ? (r.fit==='full' ? 'Full set of Beadlock' : 'Standard front / Beadlock rear') : '';
    $('hf-wheel').value=conLabel()+' · '+curSeries().k+' Series · '+modelLabel()+(fitLabel?(' — '+fitLabel):'');
    $('hf-front').value=(r.isBL?r.frontModel+' · ':'')+r.fd+'" × '+r.fw+'"  ('+money(r.fEach)+'/wheel)';
    $('hf-rear').value=r.isBL
      ? (r.rearModel+' · '+r.rd+'" × '+r.rw+'"  ('+money(r.rEach)+'/wheel)')
      : (r.square?'Same as front (square)':r.rd+'" × '+r.rw+'"  ('+money(r.rEach)+'/wheel)');
    $('hf-finish').value=finish;
    var hwStyle = modMode ? ((curSeries() && curSeries().hwHidden) ? 'Hidden' : ($('bw-hwstyle').value || '')) : '';
    $('hf-hardware').value = showsHardware() ? ($('bw-hardware').value + (hwStyle ? (' ('+hwStyle+')') : '')) : '';
    var capVal = capExcluded() ? capExcludedLabel() : $('bw-cap').value;
    $('hf-cap').value=capVal;
    $('hf-valve').value=$('bw-valve').value;
    $('hf-options').value=optsFlat;
    $('hf-estimate').value=money(r.total)+' (MSRP '+money(r.msrp)+') — set of 4, shipped';
    $('hf-summary').value =
      'VEHICLE: '+($('bw-vehicle').value||'')+'\n'+
      'SUSPENSION: '+susV+'\n'+
      'BRAKES: '+brV+'\n'+
      'WHEEL: '+$('hf-wheel').value+'\n'+
      'FRONT: '+$('hf-front').value+'\n'+
      'REAR: '+$('hf-rear').value+'\n'+
      'FINISH: '+finish+'\n'+
      (showsHardware() ? 'HARDWARE: '+$('hf-hardware').value+'\n' : '')+
      'CENTER CAP: '+capVal+'\n'+
      'VALVE STEMS: '+$('bw-valve').value+'\n'+
      'OPTIONS: '+$('hf-options').value+'\n'+
      'ESTIMATED PRICE: '+$('hf-estimate').value;
  }

  // ---- validation: required fields turn red until filled ----
  function validate(){
    var ok=true, first=null, missing=[];
    var summary=$('bw-errors');
    function fieldLabel(el){
      var field=el && el.closest ? el.closest('.ar-bw__field') : null;
      var label=field && field.querySelector('.ar-bw__label');
      return label ? label.textContent.replace(/\*/g,'').trim() : 'Required field';
    }
    function setInvalid(el, invalid){
      if(!el) return;
      el.classList.toggle('is-invalid', invalid);
      el.setAttribute('aria-invalid', invalid?'true':'false');
      if(el.classList.contains('ar-vs-native') && VS[el.id]){
        VS[el.id].trig.classList.toggle('is-invalid', invalid);
        VS[el.id].trig.setAttribute('aria-invalid', invalid?'true':'false');
      }
    }
    function fail(el, label){
      if(!el) return;
      setInvalid(el,true); ok=false; if(!first) first=el;
      missing.push(label || fieldLabel(el));
    }
    function need(el){ if(!el) return; if(el.value==null || el.value===''){ fail(el); } else { setInvalid(el,false); } }
    need($('bw-vehicle'));
    need($('bw-construction'));
    if(con()==='truck') need($('bw-lug'));
    need($('bw-series')); need($('bw-model'));
    if(isBlConstruction()) need($('bw-blfit'));
    need($('bw-fd')); need($('bw-fw'));
    if(!$('bw-square').checked){ need($('bw-rd')); need($('bw-rw')); }
    need($('bw-center'));
    if(isBeadlock()) need($('bw-blfinish'));
    if(modularMode()){ need($('bw-lip')); var sCur=curSeries(); if(sCur && sCur.lipStyle) need($('bw-lipstyle')); if(sCur && !sCur.hwHidden) need($('bw-hwstyle')); if($('bw-poliplip-want').value==='yes') need($('bw-poliplip')); }
    if(showsHardware()) need($('bw-hardware')); if(!capExcluded()) need($('bw-cap')); need($('bw-valve'));
    if(!$('bw-dcface-wrap').classList.contains('ar-bw__field--hidden') && $('bw-dcface').checked) need($('bw-dcface-color'));
    if(!$('bw-dclip-wrap').classList.contains('ar-bw__field--hidden') && $('bw-dclip').checked) need($('bw-dclip-color'));
    need(document.querySelector('[name="contact[name]"]'));
    need(document.querySelector('[name="contact[email]"]'));
    // radio groups
    var sus=root.querySelector('[data-suspension]'), susMobile=$('bw-suspension-mobile'), susOk=!!root.querySelector('[name=bw_suspension]:checked');
    sus.classList.toggle('is-invalid', !susOk); sus.setAttribute('aria-invalid', susOk?'false':'true');
    if(susMobile){ susMobile.classList.toggle('is-invalid', !susOk); susMobile.setAttribute('aria-invalid', susOk?'false':'true'); }
    if(!susOk){ ok=false; if(!first) first=(susMobile && susMobile.offsetParent!==null)?susMobile:sus; missing.push('Suspension setup'); }
    var br=root.querySelector('[data-brakes]'), brMobile=$('bw-brakes-mobile'), brOk=!!root.querySelector('[name=bw_brakes]:checked');
    br.classList.toggle('is-invalid', !brOk); br.setAttribute('aria-invalid', brOk?'false':'true');
    if(brMobile){ brMobile.classList.toggle('is-invalid', !brOk); brMobile.setAttribute('aria-invalid', brOk?'false':'true'); }
    if(!brOk){ ok=false; if(!first) first=(brMobile && brMobile.offsetParent!==null)?brMobile:br; missing.push('Brake setup'); }
    if(summary){
      if(ok){ summary.hidden=true; summary.innerHTML=''; }
      else {
        summary.hidden=false;
        summary.innerHTML='<p>Please complete the required build details:</p><ul>'+missing.filter(function(item,index){ return missing.indexOf(item)===index; }).map(function(item){ return '<li>'+specEsc(item)+'</li>'; }).join('')+'</ul>';
        summary.focus();
      }
    }
    if(first){
      var tgt=(first.classList && first.classList.contains('ar-vs-native') && VS[first.id]) ? VS[first.id].trig : first;
      tgt.scrollIntoView({behavior:'smooth', block:'center'});
    }
    return ok;
  }

  // ---- visual photo-picker (overlays a native select; select stays source of truth) ----
  var VS = {};
  function loadVSImage(node){
    var src=node && node.getAttribute('data-img-url');
    if(!src) return;
    node.style.backgroundImage='url('+src+')';
    node.removeAttribute('data-img-url');
  }
  function prepareVSImages(id){
    var v=VS[id]; if(!v) return;
    var nodes=[].slice.call(v.grid.querySelectorAll('[data-img-url]'));
    if(!nodes.length) return;
    if(v.io){ v.io.disconnect(); v.io=null; }
    if(!('IntersectionObserver' in window)){
      nodes.forEach(loadVSImage);
      return;
    }
    v.io=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting) return;
        loadVSImage(entry.target);
        v.io.unobserve(entry.target);
      });
    }, {root:v.panel, rootMargin:'120px 0px'});
    nodes.forEach(function(node){ v.io.observe(node); });
  }
  function enhanceSelect(sel, cfg){
    cfg = cfg || {};
    sel.classList.add('ar-vs-native');
    var wrap=document.createElement('div'); wrap.className='ar-vs'; if(cfg.swatch) wrap.classList.add('ar-vs--swatch'); if(cfg.text) wrap.classList.add('ar-vs--text'); if(cfg.split) wrap.classList.add('ar-vs--split');
    var trig=document.createElement('button'); trig.type='button'; trig.className='ar-vs__trigger';
    var labelNode=sel.closest('.ar-bw__field') && sel.closest('.ar-bw__field').querySelector('.ar-bw__label');
    var accessibleLabel=labelNode ? labelNode.textContent.replace(/\*/g,'').trim() : 'Choose an option';
    var panelId=sel.id+'-visual-options';
    trig.setAttribute('role','combobox');
    trig.setAttribute('aria-haspopup','listbox');
    trig.setAttribute('aria-expanded','false');
    trig.setAttribute('aria-controls',panelId);
    trig.setAttribute('aria-label',accessibleLabel);
    trig.setAttribute('aria-invalid','false');
    trig.innerHTML='<span class="ar-vs__thumb" data-empty="1"></span><span class="ar-vs__lbl is-ph"></span><svg class="ar-vs__chev" width="12" height="8" viewBox="0 0 12 8" aria-hidden="true"><path d="M1 1l5 5 5-5" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';
    var panel=document.createElement('div'); panel.className='ar-vs__panel'; panel.id=panelId; panel.setAttribute('aria-hidden','true');
    var search=null;
    if(cfg.search){ search=document.createElement('input'); search.type='text'; search.className='ar-vs__search'; search.placeholder='Search models…'; search.setAttribute('aria-label','Search '+accessibleLabel.toLowerCase()+' choices'); search.setAttribute('aria-controls',panelId+'-list'); panel.appendChild(search); }
    var grid=document.createElement('div'); grid.className='ar-vs__grid'; grid.id=panelId+'-list'; grid.setAttribute('role','listbox'); grid.setAttribute('aria-label',accessibleLabel+' choices'); panel.appendChild(grid);
    wrap.appendChild(trig); wrap.appendChild(panel);
    sel.parentNode.insertBefore(wrap, sel.nextSibling);
    VS[sel.id]={sel:sel,wrap:wrap,trig:trig,panel:panel,grid:grid,search:search,cfg:cfg,io:null};
    trig.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); toggleVS(sel.id); });
    trig.addEventListener('keydown', function(e){
      if(e.key==='Enter'||e.key===' '||e.key==='ArrowDown'||e.key==='ArrowUp'){
        e.preventDefault();
        if(!wrap.classList.contains('is-open')) openVS(sel.id);
        if(!search) focusVSOption(sel.id, e.key==='ArrowUp' ? -1 : 1);
      } else if(e.key==='Escape'){ closeVS(sel.id,true); }
    });
    if(search) search.addEventListener('input', function(){ filterVS(sel.id, this.value); });
    if(search) search.addEventListener('keydown', function(e){
      if(e.key==='Escape'){ e.preventDefault(); closeVS(sel.id,true); }
      else if(e.key==='ArrowDown'){ e.preventDefault(); focusVSOption(sel.id,1); }
    });
    sel.addEventListener('change', function(){ syncVS(sel); });
    var mo=new MutationObserver(function(){ var invalid=sel.classList.contains('is-invalid'); trig.classList.toggle('is-invalid',invalid); trig.setAttribute('aria-invalid',invalid?'true':'false'); });
    mo.observe(sel,{attributes:true,attributeFilter:['class']});
    refreshVS(sel);
  }
  function refreshVS(sel){
    if(!sel) return; var v=VS[sel.id]; if(!v) return;
    if(v.io){ v.io.disconnect(); v.io=null; }
    v.grid.innerHTML='';
    [].forEach.call(sel.options, function(o){
      if(o.value==='') return;
      var img=o.dataset.img||'';
      var b=document.createElement('button'); b.type='button'; b.className='ar-vs__opt'; b.setAttribute('data-val',o.value); b.setAttribute('role','option'); b.setAttribute('aria-selected','false');
      if(v.cfg.split){ var parts=o.textContent.split(' — '); b.innerHTML = parts.length>1 ? ('<span class="ar-vs__optlbl"><span class="ar-vs__optname">'+parts[0]+'</span><span class="ar-vs__optdesc">'+parts.slice(1).join(' — ')+'</span></span>') : ('<span class="ar-vs__optlbl"><span class="ar-vs__optname">'+o.textContent+'</span></span>'); }
      else if(v.cfg.text){ b.innerHTML='<span class="ar-vs__optlbl">'+o.textContent+'</span>'; }
      else { b.innerHTML='<span class="ar-vs__optthumb"'+(img?' data-img-url="'+img+'"':' data-empty="1"')+'></span><span class="ar-vs__optlbl">'+o.textContent+'</span>'; }
      b.addEventListener('click', function(e){ e.preventDefault(); sel.value=o.value; sel.dispatchEvent(new Event('change',{bubbles:true})); closeVS(sel.id,true); });
      b.addEventListener('keydown', function(e){
        if(e.key==='ArrowDown'||e.key==='ArrowUp'){ e.preventDefault(); focusVSOption(sel.id,e.key==='ArrowDown'?1:-1,b); }
        else if(e.key==='Home'||e.key==='End'){ e.preventDefault(); focusVSBoundary(sel.id,e.key==='End'); }
        else if(e.key==='Escape'){ e.preventDefault(); closeVS(sel.id,true); }
        else if(e.key==='Tab'){ closeVS(sel.id,false); }
      });
      v.grid.appendChild(b);
    });
    syncVS(sel);
  }
  function syncVS(sel){
    var v=VS[sel.id]; if(!v) return;
    var o=sel.options[sel.selectedIndex], val=sel.value;
    var thumb=v.trig.querySelector('.ar-vs__thumb'), lbl=v.trig.querySelector('.ar-vs__lbl');
    lbl.textContent = o ? o.textContent : 'Select…';
    if(!val){ lbl.classList.add('is-ph'); thumb.style.backgroundImage=''; thumb.setAttribute('data-empty','1'); }
    else { lbl.classList.remove('is-ph'); var img=o.dataset.img||''; if(img){ thumb.style.backgroundImage='url('+img+')'; thumb.removeAttribute('data-empty'); } else { thumb.style.backgroundImage=''; thumb.setAttribute('data-empty','1'); } }
    [].forEach.call(v.grid.children, function(b){ var selected=b.getAttribute('data-val')===val; b.classList.toggle('is-sel',selected); b.setAttribute('aria-selected',selected?'true':'false'); });
  }
  function visibleVSOptions(id){ return [].filter.call(VS[id].grid.children,function(b){ return b.style.display!=='none'; }); }
  function focusVSOption(id,direction,current){
    var options=visibleVSOptions(id); if(!options.length) return;
    var index=current ? options.indexOf(current) : -1;
    if(index<0){ index=options.findIndex(function(b){ return b.getAttribute('aria-selected')==='true'; }); }
    index=index<0 ? (direction<0?options.length-1:0) : (index+direction+options.length)%options.length;
    options[index].focus();
  }
  function focusVSBoundary(id,last){ var options=visibleVSOptions(id); if(options.length) options[last?options.length-1:0].focus(); }
  function openVS(id){
    var v=VS[id]; closeAllVS(); v.wrap.classList.add('is-open'); v.trig.setAttribute('aria-expanded','true'); v.panel.setAttribute('aria-hidden','false');
    prepareVSImages(id);
    if(v.search){ v.search.value=''; filterVS(id,''); setTimeout(function(){v.search.focus();},30); }
  }
  function closeVS(id,restoreFocus){
    var v=VS[id];
    if(!v || !v.wrap || !v.trig || !v.panel) return;
    v.wrap.classList.remove('is-open');
    v.trig.setAttribute('aria-expanded','false');
    v.panel.setAttribute('aria-hidden','true');
    if(v.io){ v.io.disconnect(); v.io=null; }
    if(restoreFocus) v.trig.focus();
  }
  function toggleVS(id){ var open=VS[id].wrap.classList.contains('is-open'); if(open) closeVS(id,true); else openVS(id); }
  function closeAllVS(){ Object.keys(VS).forEach(function(k){ closeVS(k,false); }); }
  function filterVS(id,q){ q=(q||'').toLowerCase(); [].forEach.call(VS[id].grid.children, function(b){ b.style.display = b.textContent.toLowerCase().indexOf(q)>=0?'':'none'; }); }
  document.addEventListener('click', function(e){ if(!e.target.closest('.ar-vs')) closeAllVS(); });

  // ---- build recap modal (shown on submit, before sending) ----
  var modal=null, recapTrigger=null;
  function buildModal(){
    modal=document.createElement('div'); modal.className='ar-bw__modal'; modal.setAttribute('hidden','');
    modal.innerHTML =
      '<div class="ar-bw__modal-backdrop" data-close aria-hidden="true"></div>'+
      '<div class="ar-bw__modal-card" role="dialog" aria-modal="true" aria-labelledby="bw-modal-title" tabindex="-1">'+
        '<button type="button" class="ar-bw__modal-x" data-close aria-label="Close">&times;</button>'+
        '<h3 class="ar-bw__modal-title" id="bw-modal-title">Review your bespoke build</h3>'+
        '<p class="ar-bw__modal-sub">Give it a once-over — then we’ll send it to our fitment team.</p>'+
        '<dl class="ar-bw__recap" id="bw-recap"></dl>'+
        '<div class="ar-bw__modal-total">'+
          '<p class="ar-bw__card-eyebrow">Estimated price — set of 4, shipped</p>'+
          '<div class="ar-bw__price ar-bw__modal-price"><span class="ar-bw__compare" id="bw-modal-compare"></span><span id="bw-modal-price"></span></div>'+
        '</div>'+
        '<p class="ar-bw__taxnote ar-bw__taxnote--modal">Pricing may be subject to applicable sales tax.</p>'+
        '<div class="ar-bw__modal-actions">'+
          '<button type="button" class="ar-bw__modal-edit" data-close>Edit build</button>'+
          '<button type="button" class="ar-bw__modal-confirm btn btn--primary" id="bw-modal-confirm">Confirm &amp; submit</button>'+
        '</div>'+
      '</div>';
    root.appendChild(modal);
    modal.querySelectorAll('[data-close]').forEach(function(el){ el.addEventListener('click', hideRecap); });
    modal.querySelector('#bw-modal-confirm').addEventListener('click', function(){
      if(INQUIRY_ENDPOINT){ submitInquiry(); }   // proxy path: create draft order + branded email
      else { var f=document.getElementById('ar-bw-form'); if(f) f.submit(); }   // fallback: Shopify contact form
    });
    document.addEventListener('keydown', function(e){
      if(!modal || modal.hasAttribute('hidden')) return;
      if(e.key==='Escape'){ e.preventDefault(); hideRecap(); return; }
      if(e.key!=='Tab') return;
      var focusable=[].filter.call(modal.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),function(el){ return el.offsetParent!==null; });
      if(!focusable.length) return;
      var first=focusable[0], last=focusable[focusable.length-1];
      if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
    });
  }
  function recapRow(dt,dd){ return dd ? ('<div class="ar-bw__recap-row"><dt>'+esc(dt)+'</dt><dd>'+esc(dd).replace(/\n/g,'<br>')+'</dd></div>') : ''; }
  function showRecap(){
    if(!modal) buildModal();
    var g=document.getElementById.bind(document);
    g('bw-recap').innerHTML =
      recapRow('Vehicle', g('bw-vehicle').value) +
      recapRow('Suspension', g('hf-suspension').value) +
      recapRow('Brakes', g('hf-brakes').value) +
      recapRow('Wheel', g('hf-wheel').value) +
      recapRow('Front', g('hf-front').value) +
      recapRow('Rear', g('hf-rear').value) +
      recapRow('Finish', g('hf-finish').value) +
      recapRow('Hardware', g('hf-hardware').value) +
      recapRow('Center cap', g('hf-cap').value) +
      recapRow('Valve stems', g('hf-valve').value) +
      recapRow('Options', g('hf-options').value);
    g('bw-modal-compare').textContent = g('bw-compare').textContent;
    g('bw-modal-price').textContent = g('bw-total').textContent;
    recapTrigger=document.activeElement;
    modal.removeAttribute('hidden'); document.body.style.overflow='hidden';
    var card=modal.querySelector('.ar-bw__modal-card'); if(card) card.focus();
  }
  function hideRecap(){
    if(modal){
      modal.setAttribute('hidden',''); document.body.style.overflow='';
      if(recapTrigger && document.contains(recapTrigger)) recapTrigger.focus();
      recapTrigger=null;
    }
  }

  // ---- inquiry submission (proxy → draft order + branded email) ----
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){ return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'})[c]; }); }
  function emailAssetBase(){ return (ASSET_BASE.indexOf('//')===0 ? ('https:'+ASSET_BASE) : ASSET_BASE); }
  // audience: 'internal' (the team's lead email — reply-to=customer) or 'customer' (confirmation — reply-to=team)
  function buildEmailHtml(d, audience){
    audience = audience || 'internal';
    var A=emailAssetBase();
    var save=(d.pricing.msrp||0)-(d.pricing.total||0);
    function specRow(l,v){ return '<tr style="border-bottom:1px solid #eef0f2;"><td style="padding:8px 0;color:#16181c;font-weight:700;width:150px;vertical-align:top;">'+esc(l)+'</td><td style="padding:8px 0;color:#3a3d42;">'+esc(v)+'</td></tr>'; }
    function pairRow(l,lines){ var b=lines.map(function(x){ return '<div style="padding:1px 0;line-height:1.45;"><span style="color:#16181c;font-weight:700;">'+esc(x[0])+':</span> <span style="color:#3a3d42;">'+esc(x[1])+'</span></div>'; }).join(''); return '<tr style="border-bottom:1px solid #eef0f2;"><td style="padding:8px 0;color:#16181c;font-weight:700;width:150px;vertical-align:top;">'+esc(l)+'</td><td style="padding:8px 0;">'+b+'</td></tr>'; }
    function optRow(l,lines){ var b=lines.length?lines.map(function(x){ return '<div style="padding:1px 0;line-height:1.45;"><span style="color:#3a3d42;">'+esc(x[0])+'</span>'+(x[1]?' <span style="color:#71757c;">— '+esc(x[1])+'</span>':'')+'</div>'; }).join(''):'<span style="color:#3a3d42;">None</span>'; return '<tr style="border-bottom:1px solid #eef0f2;"><td style="padding:8px 0;color:#16181c;font-weight:700;width:150px;vertical-align:top;">'+esc(l)+'</td><td style="padding:8px 0;">'+b+'</td></tr>'; }
    function custRow(l,v,bold){ return '<tr><td style="padding:3px 0;color:#71757c;width:110px;vertical-align:top;">'+esc(l)+'</td><td'+(bold?' style="font-weight:700;"':'')+'>'+v+'</td></tr>'; }
    var specHtml=(d.spec1||[]).map(function(f){ return specRow(f[0],f[1]); }).join('')+(d.finish&&d.finish.length?pairRow('Finish',d.finish):'')+(d.spec2||[]).map(function(f){ return specRow(f[0],f[1]); }).join('')+optRow('Options',d.options||[]);
    var plines=(d.pricing.lines||[]).map(function(l){ return '<tr><td style="padding:1px 0;line-height:18px;">'+esc(l[0])+'</td><td style="text-align:right;padding:1px 0;line-height:18px;white-space:nowrap;">'+esc(l[1])+'</td></tr>'; }).join('');
    // top block differs by audience: internal = lead card (name + contact); customer = confirmation + their details
    var firstName=((d.customer.name||'').trim().split(/\s+/)[0])||'there';
    var notesHeading = audience==='customer' ? 'Your notes' : 'Customer notes';
    var leadHtml;
    if(audience==='customer'){
      leadHtml='<tr><td class="em-px" style="padding:22px 28px 4px;">'+
        '<div style="font-size:19px;font-weight:700;color:#16181c;margin:0 0 8px;">Thanks, '+esc(firstName)+' — we’ve got your build.</div>'+
        '<div style="font-size:14px;color:#3a3d42;line-height:1.55;">Your BC Forged bespoke inquiry is in. A fitment specialist will review your spec and reach out within one business day to confirm the details and finalize your order. Here’s a copy of what you submitted for your records.</div>'+
        '<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="width:100%;font-size:14px;color:#3a3d42;margin-top:14px;">'+custRow('Vehicle',esc(d.vehicle||'—'),true)+(d.suspension?custRow('Suspension',esc(d.suspension)):'')+(d.brakes?custRow('Brakes',esc(d.brakes)):'')+'</table></td></tr>';
    } else {
      leadHtml='<tr><td class="em-px" style="padding:22px 28px 4px;"><div style="font-size:11px;letter-spacing:1px;text-transform:uppercase;color:#e4002b;font-weight:700;">Customer</div><div style="font-size:18px;font-weight:700;color:#16181c;margin:6px 0 2px;">'+esc(d.customer.name||'—')+'</div><table cellpadding="0" cellspacing="0" border="0" role="presentation" style="width:100%;font-size:14px;color:#3a3d42;margin-top:8px;">'+custRow('Email','<a href="mailto:'+esc(d.customer.email||'')+'" style="color:#1a6cc9;text-decoration:none;">'+esc(d.customer.email||'')+'</a>')+custRow('Phone',esc(d.customer.phone||'—'))+custRow('Vehicle',esc(d.vehicle||'—'),true)+(d.suspension?custRow('Suspension',esc(d.suspension)):'')+(d.brakes?custRow('Brakes',esc(d.brakes)):'')+'</table></td></tr>';
    }
    return ''+
    '<!doctype html><html lang="en" xmlns:o="urn:schemas-microsoft-com:office:office"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]--><style>.em-header{background-color:#0e0f12!important;background-image:linear-gradient(#0e0f12,#0e0f12)!important}u + .body .gmail-blend-screen{background:#000;mix-blend-mode:screen}u + .body .gmail-blend-difference{background:#000;mix-blend-mode:difference}[data-ogsc] .em-header{background-color:#0e0f12!important;background-image:linear-gradient(#0e0f12,#0e0f12)!important}@media (prefers-color-scheme:dark){.em-header{background-color:#0e0f12!important;background-image:linear-gradient(#0e0f12,#0e0f12)!important}.em-header-title{color:#ffffff!important;-webkit-text-fill-color:#ffffff!important}.em-header-copy{color:#9aa0a8!important}}@media only screen and (max-width:600px){.em-bg{padding:8px!important}.em-card{width:100%!important}.em-px{padding-left:18px!important;padding-right:18px!important}}</style><!--[if mso]><style>table{border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt;}td,div,p,a,span{mso-line-height-rule:exactly;}.em-card{width:560px!important;}body,table,td,div,p,span,a{font-family:Arial,Helvetica,sans-serif!important;}</style><![endif]--></head><body class="body" style="margin:0;padding:0;background:#eceef1;">'+
    '<div class="em-bg" style="margin:0;padding:24px;background:#eceef1;font-family:Arial,Helvetica,sans-serif;">'+
    '<!--[if mso]><table role="presentation" align="center" width="560" cellpadding="0" cellspacing="0" border="0"><tr><td><![endif]-->'+
    '<table class="em-card" width="560" align="center" cellpadding="0" cellspacing="0" border="0" role="presentation" bgcolor="#ffffff" style="width:560px;max-width:100%;background:#ffffff;border-radius:10px;overflow:hidden;border:1px solid #e2e5e9;">'+
    '<tr><td class="em-header em-px" bgcolor="#0e0f12" style="padding:26px 28px 24px;background-color:#0e0f12!important;background-image:linear-gradient(#0e0f12,#0e0f12)!important;border-radius:10px 10px 0 0;">'+
      '<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="width:100%;"><tr>'+
        '<td align="left" valign="middle" style="padding:0;"><img src="'+A+'speedbred-logo-light.png?v='+ASSET_VER+'" alt="SPEEDBRED" width="145" style="width:145px;max-width:100%;height:auto;display:block;border:0;"></td>'+
        '<td align="right" valign="middle" style="padding:0 0 0 16px;"><img src="'+A+'bc-forged-white.png?v='+ASSET_VER+'" alt="BC Forged" width="132" style="width:132px;max-width:100%;height:auto;display:block;border:0;margin-left:auto;"></td>'+
      '</tr></table>'+
      '<div style="width:54px;height:4px;line-height:4px;font-size:0;background-color:#e4002b;background:#e4002b;margin:22px 0 15px;">&nbsp;</div>'+
      '<div class="gmail-blend-screen"><div class="gmail-blend-difference"><div class="em-header-title" style="font-size:23px;line-height:1.2;font-weight:700;color:#ffffff!important;-webkit-text-fill-color:#ffffff!important;text-shadow:0 0 0 #ffffff;margin:0;"><font color="#ffffff" style="color:#ffffff!important;-webkit-text-fill-color:#ffffff!important;">BC Forged Bespoke Wheel Inquiry</font></div></div></div>'+
      '<div class="em-header-copy" style="font-size:14px;line-height:1.45;color:#9aa0a8!important;margin-top:6px;">SPEEDBRED · new build request from the configurator</div>'+
    '</td></tr>'+
    leadHtml+
    '<tr><td class="em-px" style="padding:18px 28px 4px;"><div style="font-size:11px;letter-spacing:1px;text-transform:uppercase;color:#e4002b;font-weight:700;margin-bottom:4px;">Build specification</div><table cellpadding="0" cellspacing="0" border="0" role="presentation" style="width:100%;font-size:14px;border-collapse:collapse;">'+specHtml+'</table></td></tr>'+
    '<tr><td class="em-px" style="padding:18px 28px 6px;"><table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" bgcolor="#0e0f12" style="background-color:#0e0f12;background:#0e0f12;border-radius:8px;"><tr><td bgcolor="#0e0f12" style="background-color:#0e0f12;padding:18px 20px;border-radius:8px;"><div style="color:#9aa0a8;font-size:11px;letter-spacing:1px;text-transform:uppercase;font-weight:700;">Estimated price — set of 4, shipped</div><div style="margin-top:8px;"><span style="color:#7c8088;text-decoration:line-through;font-size:16px;">'+money(d.pricing.msrp)+'</span><span style="color:#ffffff;font-size:30px;font-weight:800;margin-left:10px;">'+money(d.pricing.total)+'</span></div>'+(save>0?'<div style="color:#39c46a;font-size:13px;margin-top:4px;">Saves '+money(save)+' vs. MSRP</div>':'')+'<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="width:100%;color:#c9ccd1;font-size:13px;margin-top:14px;border-top:1px solid #26282d;">'+plines+'</table><div style="color:#71757c;font-size:11px;margin-top:12px;">Pricing may be subject to applicable sales tax. A 50% non-refundable deposit places the order; the balance is charged before the wheels ship.</div></td></tr></table></td></tr>'+
    (d.notes?'<tr><td class="em-px" style="padding:14px 28px 4px;"><div style="font-size:11px;letter-spacing:1px;text-transform:uppercase;color:#e4002b;font-weight:700;">'+notesHeading+'</div><div style="font-size:14px;color:#3a3d42;margin-top:6px;font-style:italic;">“'+esc(d.notes)+'”</div></td></tr>':'')+
    '<tr><td class="em-px" style="padding:18px 28px 24px;border-top:1px solid #eef0f2;"><div style="font-size:12px;color:#9aa0a8;">BC Forged Bespoke Wheel Program · speedbred.com</div></td></tr>'+
    '</table><!--[if mso]></td></tr></table><![endif]--></div></body></html>';
  }
  function buildEmailText(d){
    var L=['BC Forged Bespoke Wheel Inquiry','','CUSTOMER: '+(d.customer.name||''),'Email: '+(d.customer.email||''),'Phone: '+(d.customer.phone||''),'Vehicle: '+(d.vehicle||''),'','BUILD:'];
    d.fields.forEach(function(f){ L.push('  '+f[0]+': '+f[1]); });
    L.push(''); L.push('PRICE (set of 4, shipped): '+money(d.pricing.total)+' (MSRP '+money(d.pricing.msrp)+')');
    (d.pricing.lines||[]).forEach(function(l){ L.push('  '+l[0]+': '+l[1]); });
    if(d.notes){ L.push(''); L.push('NOTES: '+d.notes); }
    return L.join('\n');
  }
  // customer-framed plain-text alternative — mirrors the confirmation HTML (so HTML/text agree).
  // Reuses the trimmed d.lineItem (title + properties) that the draft order shows.
  function buildCustomerEmailText(d){
    var first=((d.customer&&d.customer.name||'').trim().split(/\s+/)[0])||'there';
    var L=[];
    L.push('Thanks, '+first+' — we’ve got your build.');
    L.push('');
    L.push('Your BC Forged bespoke inquiry is in. A fitment specialist will review your spec and reach out within one business day to confirm the details and finalize your order. Here’s a copy for your records:');
    L.push('');
    if(d.vehicle) L.push('Vehicle: '+d.vehicle);
    if(d.suspension) L.push('Suspension: '+d.suspension);
    if(d.brakes) L.push('Brakes: '+d.brakes);
    var li=d.lineItem||{};
    L.push(''); L.push(li.title || 'Your BC Forged bespoke build');
    (li.properties||[]).forEach(function(pr){
      var key=pr[0], val=String(pr[1]==null?'':pr[1]);
      if(val.indexOf('\n')>=0){ L.push('  '+key+':'); val.split('\n').forEach(function(ln){ L.push('    '+ln.replace(/^---\s*/,'')); }); }
      else { L.push('  '+key+': '+val.replace(/^---\s*/,'')); }
    });
    L.push('');
    L.push('Estimated total (set of 4, shipped): '+money(d.pricing.total)+' (MSRP '+money(d.pricing.msrp)+')');
    if(d.notes){ L.push(''); L.push('Your notes: '+d.notes); }
    L.push('');
    L.push('Questions? Just reply to this email.');
    L.push('SPEEDBRED · BC Forged Bespoke Wheel Program · speedbred.com');
    return L.join('\n');
  }
  // finish broken into its own labelled lines; lip label mirrors the selector (Lip / Barrel → Barrel on override); polished lip only when chosen
  function finishLines(){
    var g=document.getElementById.bind(document), out=[];
    if(modularMode()){
      if(g('bw-center').value) out.push(['Center', g('bw-center').value]);
      if(g('bw-lip').value) out.push([barrelOverride()?'Barrel':'Lip / Barrel', g('bw-lip').value]);
      if(!g('bw-lipstylerow').classList.contains('ar-bw__field--hidden') && g('bw-lipstyle').value) out.push(['Lip Style', g('bw-lipstyle').value]);
      if(g('bw-poliplip-want').value==='yes' && g('bw-poliplip').value) out.push(['Polished Lip', g('bw-poliplip').value.replace(' (+$100/wheel)','')]);
    } else if(isBeadlock()){
      if(g('bw-center').value) out.push(['Finish', g('bw-center').value]);
      if(g('bw-blfinish').value) out.push(['Beadlock', g('bw-blfinish').value]);
    } else if(g('bw-center').value){ out.push(['Finish', g('bw-center').value]); }
    return out;
  }
  // upcharge options, each with its set price (×4)
  function optionLines(){
    var g=document.getElementById.bind(document), out=[];
    if(isBeadlock()) out.push(['Knurled bead seats (standard)','Included']);
    if(g('bw-knurled').checked) out.push(['Knurled bead seats', money(200)]);
    if(g('bw-oemcap').checked) out.push(['OEM cap machining', money(400)]);
    if(g('bw-oemlock').checked) out.push(['OEM center lock', money(400)]);
    if(!g('bw-dcface-wrap').classList.contains('ar-bw__field--hidden') && g('bw-dcface').checked) out.push(['Diamond-cut face'+(g('bw-dcface-color').value?' — '+g('bw-dcface-color').value:''), money(400)]);
    if(!g('bw-dclip-wrap').classList.contains('ar-bw__field--hidden') && g('bw-dclip').checked) out.push(['Diamond-cut lip'+(g('bw-dclip-color').value?' — '+g('bw-dclip-color').value:''), money(400)]);
    return out;
  }
  function inquiryPayload(){
    var g=document.getElementById.bind(document), r=calc();
    function fv(sel){ var e=document.querySelector(sel); return e?e.value:''; }
    var name=fv('[name="contact[name]"]'), email=fv('[name="contact[email]"]'), phone=fv('[name="contact[phone]"]');
    var vehicle=g('bw-vehicle').value||'', notes=fv('[name="contact[body]"]');
    var susV=g('hf-suspension').value, brV=g('hf-brakes').value;
    var fin=finishLines(), opt=optionLines();
    var conRows=[['Construction',conLabel()],['Series',curSeries()?curSeries().k+' Series':''],['Model',modelLabel()]];   // kept separate so the draft-order line-item title still builds
    var sizeRows=[['Front',g('hf-front').value],['Rear',g('hf-rear').value]];
    var spec1=[['Wheel', g('hf-wheel').value]].concat(sizeRows).filter(function(f){ return f[1]; });   // email: one combined wheel line, like the recap
    var spec2=[['Hardware',g('hf-hardware').value],['Center cap',g('hf-cap').value],['Valve stems',g('hf-valve').value]].filter(function(f){ return f[1]; });
    var finFlat=fin.map(function(x){ return x[0]+': '+x[1]; }).join(' | ');
    var optFlat=opt.length?opt.map(function(x){ return x[0]+(x[1]&&x[1]!=='Included'?(' ('+x[1]+')'):''); }).join(', '):'None';
    var fields=conRows.concat(sizeRows, [['Finish',finFlat]], spec2, [['Options',optFlat],['Suspension',susV],['Brakes',brV]]).filter(function(f){ return f[1]; });
    // ---- trimmed PRODUCT line item (the custom item on the draft order) ----
    // Only the build-sheet essentials ride on the product itself; the full order detail (customer,
    // vehicle, suspension/brakes, pricing, notes) stays at the ORDER level (note + attributes).
    // Finish/Options are grouped with "--- " bullets — they read as a nested list when a viewer
    // keeps line breaks, and degrade to a "--- "-delimited single line if one collapses them.
    var liModel = g('bw-model').value || modelLabel() || 'Custom';
    var liProps = [
      ['Front', (r.isBL?r.frontModel+' · ':'')+r.fd+'x'+r.fw+' ('+money(r.fEach)+'/wheel)'],
      ['Rear',  r.square ? 'Same as front (square)' : ((r.isBL?r.rearModel+' · ':'')+r.rd+'x'+r.rw+' ('+money(r.rEach)+'/wheel)')],
      ['Finish', fin.map(function(x){ return '--- '+x[0]+': '+x[1]; }).join('\n')]
    ];
    if(showsHardware() && g('hf-hardware').value) liProps.push(['Hardware', g('hf-hardware').value]);
    if(g('hf-cap').value) liProps.push(['Center Cap', g('hf-cap').value]);
    if(g('hf-valve').value) liProps.push(['Valve Stems', g('hf-valve').value]);
    liProps.push(['Options', opt.length ? opt.map(function(x){ return '--- '+x[0]+(x[1]&&x[1]!=='Included'?(' ('+x[1]+')'):''); }).join('\n') : 'None']);
    if(r.shipLine) liProps.push(['Shipping', money(r.shipLine[1])]);
    var lineItem = { title:'BC Forged '+liModel+' (set of 4) - Bespoke Build', properties:liProps.filter(function(f){ return f[1]; }) };
    var pricing={ total:r.total||0, msrp:r.msrp||0, currency:'USD', lines:[] };
    (r.baseLines||[]).forEach(function(l){ pricing.lines.push([l[0]+' — '+l[1], money(l[2])]); });
    (r.upLines||[]).forEach(function(l){ pricing.lines.push([l[0], money(l[1])]); });
    if(r.shipLine) pricing.lines.push([r.shipLine[0], money(r.shipLine[1])]);
    // ---- itemized draft order: ONE wheel line "BC Forged <model> (set of 4)" priced at the set MSRP
    // with a single fixed discount that nets it to MAP ($50/wheel = $200/set in the standard case),
    // each upgrade as its own line, and shipping as the ORDER's shipping line (not a product line).
    // Build specs live in the order NOTE (staff-facing format below) and ride as line properties too. ----
    var dModel = g('bw-model').value || modelLabel() || 'Custom';
    function selLbl(id){ var x=selImg(id); return x?x.label:''; }
    // spec rows in the order/labels the shop wants; blanks dropped. Every upcharge selection shows its
    // adder inline, e.g. "Diamond-Cut Face: Gloss Brushed Clear (+$400)". px() formats that tag.
    var frontSpec=(r.isBL?r.frontModel+' · ':'')+r.fd+'" × '+r.fw+'"';
    var rearSpec = r.square ? 'Same as front (square)' : ((r.isBL?r.rearModel+' · ':'')+r.rd+'" × '+r.rw+'"');
    var lipStyleVal = (g('bw-lipstylerow') && !g('bw-lipstylerow').classList.contains('ar-bw__field--hidden')) ? g('bw-lipstyle').value : '';
    function px(amt){ return amt>0 ? ' (+'+money(amt)+')' : ''; }
    // diamond-cut FACE (most series) / LIP (TD/TH): $100/wheel ($400/set). A diamond-cut FACE replaces the
    // painted center face, so Center Finish drops out when it's on.
    var dcFaceOn = !g('bw-dcface-wrap').classList.contains('ar-bw__field--hidden') && g('bw-dcface').checked;
    var dcLipOn  = !g('bw-dclip-wrap').classList.contains('ar-bw__field--hidden')  && g('bw-dclip').checked;
    var poliWant = modularMode() && g('bw-poliplip-want').value==='yes';
    var poliVal  = poliWant ? g('bw-poliplip').value.replace(' (+$100/wheel)','') : '';   // strip the per-wheel tag; set-price tag added below
    var poliPaid = poliWant && g('bw-poliplip').value.indexOf('+$100')>=0;                // paid polished colors = $100/wheel ($400/set)
    var specRows = [
      ['Front', frontSpec + ' (2× ' + money(r.fEach) + ')'],
      ['Rear', rearSpec + ' (2× ' + money(r.rEach) + ')'],
      ['Center Finish', dcFaceOn ? '' : selLbl('bw-center')],
      ['Lip / Barrel Finish', selLbl('bw-lip')],
      ['Lip Style', lipStyleVal],
      ['Diamond-Cut Face', dcFaceOn ? (g('bw-dcface-color').value || 'Yes') + px(400) : ''],
      ['Diamond-Cut Lip', dcLipOn ? (g('bw-dclip-color').value || 'Yes') + px(400) : ''],
      ['Beadlock Finish', isBeadlock()?selLbl('bw-blfinish'):''],
      ['Polished Lip', poliVal ? poliVal + (poliPaid ? px(400) : '') : ''],
      ['Hardware', showsHardware()?g('hf-hardware').value:''],
      ['Center Cap', g('hf-cap').value ? g('hf-cap').value + (capExcluded() ? px(400) : '') : ''],
      ['Bead Seats', g('bw-knurled').checked ? 'Knurled' + px(200) : ''],
      ['Valve Stems', g('hf-valve').value]
    ].filter(function(x){ return x[1]; });
    var specNote = specRows.map(function(x){ return x[0]+': '+x[1]; }).join('\n');
    // ONE wheel line = all-in product cost (base + EVERY upcharge), priced at the net (MAP) total minus
    // shipping. Shipping rides its OWN line item that is tax-exempt + requiresShipping:false (not taxed,
    // not treated as a physical product). BOTH lines carry the removable 50% "Deposit" discount, so the
    // deposit invoice collects half of everything (incl. shipping); staff removes both to bill the balance.
    var shipAmt = r.shipLine ? r.shipLine[1] : 0;
    var productAllIn = (r.total||0) - shipAmt;   // r.total = base + upcharges + shipping
    var draftLines = [
      { title:'BC Forged '+dModel+' (set of 4)', quantity:1, unitPrice:productAllIn, discountPct:50, discountTitle:'Deposit', properties:specRows, requiresShipping:true, taxable:true }
    ];
    if(shipAmt > 0){ draftLines.push({ title:r.shipLine[0], quantity:1, unitPrice:shipAmt, discountPct:50, discountTitle:'Deposit', properties:[], requiresShipping:false, taxable:false }); }
    var draft = { lineItems:draftLines, note:specNote };
    var hp=(document.querySelector('[name="bw_url"]')||{}).value||'';   // honeypot — empty for humans
    var cfToken=(document.querySelector('[name="cf-turnstile-response"]')||{}).value||'';   // Cloudflare Turnstile token
    var configuration={version:'4362a89b8d7aa648',construction:con(),series:curSeries().k,model:g('bw-model').value,lug:g('bw-lug').value,square:r.square,beadlockFitment:isBlConstruction()?blFitment():'',front:{diameter:r.fd,width:Number(r.fw)},rear:{diameter:r.rd,width:Number(r.rw)},options:{knurled:g('bw-knurled').checked,oemCap:g('bw-oemcap').checked,oemLock:g('bw-oemlock').checked,diamondFace:dcFaceOn,diamondLip:dcLipOn,polishedLip:poliWant?g('bw-poliplip').value:''}};
    var d={ subject:'BC Forged Bespoke Inquiry: '+(name||'New customer')+' ('+(vehicle||'vehicle TBD')+')', customer:{name:name,email:email,phone:phone}, vehicle:vehicle, suspension:susV, brakes:brV, notes:notes, spec1:spec1, finish:fin, spec2:spec2, options:opt, fields:fields, lineItem:lineItem, draft:draft, configuration:configuration, pricing:pricing, summary:g('hf-summary').value, hp:hp, cfToken:cfToken, source:'bespoke-configurator' };
    d.html=buildEmailHtml(d,'internal'); d.text=buildEmailText(d);
    d.customerSubject='We’ve received your BC Forged bespoke inquiry — SPEEDBRED';
    d.customerHtml=buildEmailHtml(d,'customer');
    d.customerText=buildCustomerEmailText(d);
    return d;
  }
  function submitInquiry(){
    var btn=document.getElementById('bw-modal-confirm'); if(btn && btn.dataset.busy) return;
    var data; try{ data=inquiryPayload(); }catch(e){ inquiryError(e); return; }
    if(btn){ btn.dataset.busy='1'; btn.disabled=true; btn.textContent='Sending…'; }
    fetch(INQUIRY_ENDPOINT, { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(data) })
      .then(function(res){ return res.json().catch(function(){ return {}; }).then(function(body){ if(!res.ok || body.ok!==true){ var error=new Error('Inquiry request failed'); error.customerMessage=typeof body.error==='string'?body.error:'Sorry — that didn’t go through. Please try again in a moment.'; throw error; } return body; }); })
      .then(function(){ inquirySuccess(); })
      .catch(function(err){ if(btn){ btn.dataset.busy=''; btn.disabled=false; btn.innerHTML='Confirm &amp; submit'; } inquiryError(err); });
  }
  function inquirySuccess(){
    var card=modal && modal.querySelector('.ar-bw__modal-card');
    if(card){ card.innerHTML='<button type="button" class="ar-bw__modal-x" data-close aria-label="Close">&times;</button><div role="status" style="padding:8px 4px;"><h3 class="ar-bw__modal-title" id="bw-modal-title">'+esc(SUCCESS_TITLE)+'</h3><p style="color:var(--ar_muted,#b8bec8);">'+esc(SUCCESS_BODY)+'</p></div><div class="ar-bw__modal-actions"><button type="button" class="ar-bw__modal-confirm btn btn--primary" data-close>Done</button></div>';
      card.querySelectorAll('[data-close]').forEach(function(el){ el.addEventListener('click', hideRecap); });
      card.focus();
    } else { try{ alert(SUCCESS_TITLE); }catch(e){} }
  }
  function inquiryError(err){
    var actions=modal && modal.querySelector('.ar-bw__modal-actions');
    if(actions){ var p=modal.querySelector('.ar-bw__modal-err'); if(!p){ p=document.createElement('p'); p.className='ar-bw__modal-err'; p.setAttribute('role','alert'); p.style.cssText='color:#e24b4a;font-size:13px;margin:10px 0 0;'; actions.parentNode.insertBefore(p, actions); } p.textContent=(err && err.customerMessage)||'Sorry — that didn’t go through. Please try again in a moment.'; }
    try{ console.error('[bespoke inquiry]', err); }catch(e){}
  }

  // ---- wire up ----
  function syncMobileChoice(name, selectId){
    var select=$(selectId);
    if(!select) return;
    root.querySelectorAll('[name="'+name+'"]').forEach(function(radio){
      radio.addEventListener('change', function(){
        if(this.checked) select.value=this.value;
        select.classList.remove('is-invalid');
        select.setAttribute('aria-invalid','false');
      });
    });
    select.addEventListener('change', function(){
      var radio=[].slice.call(root.querySelectorAll('[name="'+name+'"]')).find(function(item){ return item.value===select.value; });
      if(radio){ radio.checked=true; radio.dispatchEvent(new Event('change',{bubbles:true})); }
    });
  }
  syncMobileChoice('bw_suspension','bw-suspension-mobile');
  syncMobileChoice('bw_brakes','bw-brakes-mobile');
  document.querySelectorAll('[data-suspension] input').forEach(function(el){ el.addEventListener('change', function(){ var group=root.querySelector('[data-suspension]'); group.classList.remove('is-invalid'); group.setAttribute('aria-invalid','false'); root.querySelector('[data-suspension-other]').classList.toggle('ar-bw__field--hidden', this.value!=='Other'); }); });
  document.querySelectorAll('[data-brakes] input').forEach(function(el){ el.addEventListener('change', function(){ var group=root.querySelector('[data-brakes]'); group.classList.remove('is-invalid'); group.setAttribute('aria-invalid','false'); root.querySelector('[data-brakes-other]').classList.toggle('ar-bw__field--hidden', this.value.indexOf('Custom')!==0); }); });
  root.querySelectorAll('input, select, textarea').forEach(function(el){ var clr=function(){ el.classList.remove('is-invalid'); el.setAttribute('aria-invalid','false'); if(VS[el.id]){ VS[el.id].trig.classList.remove('is-invalid'); VS[el.id].trig.setAttribute('aria-invalid','false'); } }; el.addEventListener('change', clr); el.addEventListener('input', clr); });

  $('bw-construction').addEventListener('change', function(){ fillSeries(); render(); });
  $('bw-lug').addEventListener('change', function(){ fillSeries(); render(); });
  $('bw-series').addEventListener('change', function(){ fillModels(); render(); });
  $('bw-model').addEventListener('change', render);
  ['bw-fd','bw-rd'].forEach(function(id){ $(id).addEventListener('change', function(){ fillWidths(); render(); }); });
  // OEM cap machining and OEM center lock are mutually exclusive (the center is set up for one or the other)
  $('bw-oemcap').addEventListener('change', function(){ if(this.checked) $('bw-oemlock').checked=false; });
  $('bw-oemlock').addEventListener('change', function(){ if(this.checked) $('bw-oemcap').checked=false; });
  ['bw-blfit','bw-blfinish','bw-fw','bw-rw','bw-center','bw-lip','bw-lipstyle','bw-poliplip-want','bw-poliplip','bw-hardware','bw-hwstyle','bw-cap','bw-valve','bw-region','bw-knurled','bw-oemcap','bw-oemlock','bw-dcface','bw-dcface-color','bw-dclip','bw-dclip-color','bw-square'].forEach(function(id){ $(id).addEventListener('change', render); });

  var formEl = document.getElementById('ar-bw-form');
  function openRecap(){ if(!validate()) return; pack(); showRecap(); }
  if(formEl){
    formEl.noValidate = true; // use our own red-field validation uniformly across all fields
    // block native/theme submit (incl. Enter key) — we submit only after recap confirm
    formEl.addEventListener('submit', function(e){ e.preventDefault(); e.stopImmediatePropagation(); openRecap(); }, true);
  }
  var mainBtn = $('bw-mainsubmit');
  if(mainBtn){ mainBtn.addEventListener('click', function(e){ e.preventDefault(); openRecap(); }); }

  // floating price pill — show when the estimate card is off-screen AND a price is ready
  var floatEl = $('bw-float'), card = root.querySelector('.ar-bw__card');
  if(floatEl && card && 'IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ cardOff = !e.isIntersecting; });
      updateFloat();
    }, {threshold: 0, rootMargin: '0px 0px -40px 0px'});
    io.observe(card);
  }
  var cta = $('bw-float-cta');
  if(cta){ cta.addEventListener('click', function(e){ e.preventDefault(); openRecap(); }); }

  // init — enhance all selects first (unified style), then populate
  enhanceSelect($('bw-construction'), {text:true, split:true});
  enhanceSelect($('bw-lug'), {text:true, split:true});
  enhanceSelect($('bw-series'), {text:true});
  enhanceSelect($('bw-model'), {search:true});
  enhanceSelect($('bw-blfit'), {text:true});
  enhanceSelect($('bw-fd'), {text:true});
  enhanceSelect($('bw-rd'), {text:true});
  enhanceSelect($('bw-fw'), {text:true});
  enhanceSelect($('bw-rw'), {text:true});
  enhanceSelect($('bw-center'), {swatch:true});
  enhanceSelect($('bw-lip'), {swatch:true});
  enhanceSelect($('bw-blfinish'), {swatch:true});
  enhanceSelect($('bw-lipstyle'), {text:true});
  enhanceSelect($('bw-poliplip-want'), {text:true});
  enhanceSelect($('bw-poliplip'), {text:true});
  enhanceSelect($('bw-hardware'), {swatch:true});
  enhanceSelect($('bw-hwstyle'), {text:true});
  enhanceSelect($('bw-cap'), {swatch:true});
  enhanceSelect($('bw-valve'), {swatch:true});
  enhanceSelect($('bw-dcface-color'), {text:true});
  enhanceSelect($('bw-dclip-color'), {text:true});
  enhanceSelect($('bw-region'), {text:true});
  fillSeries(); render();

  // ---- TEST PREFILL ----
  // Append ?prefill=y to the page URL to auto-fill a complete, valid, submittable build (defaults to
  // Modular). Use the full construction name to exercise a specific one:
  // ?prefill=monoblock | modular | beadlock | truck (first valid option each step), OR a named saved
  // build like ?prefill=porsche (see PRESETS below). For QA only — it does NOT submit the form.
  function arPrefill(which){
    function gid(id){ return document.getElementById(id); }
    function firstVal(id){ var s=gid(id); if(!s) return ''; for(var i=0;i<s.options.length;i++){ if(s.options[i].value) return s.options[i].value; } return ''; }
    function setSel(id,v){ var s=gid(id); if(!s||v==null||v==='') return; s.value=v; s.dispatchEvent(new Event('change',{bubbles:true})); }
    function vis(id){ var e=gid(id); return !!e && !e.classList.contains('ar-bw__field--hidden'); }
    function radio(name,val){ var r = val ? document.querySelector('[name='+name+'][value="'+val+'"]') : null; if(!r) r=document.querySelector('[name='+name+']'); if(r){ r.checked=true; r.dispatchEvent(new Event('change',{bubbles:true})); } }
    function chkOn(id){ var c=gid(id); if(c && !c.checked) c.click(); }
    // Named saved builds (real configurations). Add more here as needed.
    var PRESETS = {
      porsche: { vehicle:'2020 Porsche 911 Carrera S (992)', suspension:'Coilovers — Moderate Drop', brakes:'OEM Brakes — Steel',
        con:'mod', series:'MHE', model:'MHE28', square:false, fd:'20', fw:'8.5', rd:'21', rw:'11.5',
        center:'Satin Brushed Graphite Grey', lip:'Gloss Black', lipstyle:'Step Lip', hardware:'Black', cap:'BC CT Style', valve:'Black', region:'us', knurled:true }
    };
    var MAP = { monoblock:'mono', mono:'mono', modular:'mod', mod:'mod', beadlock:'bl', bl:'bl', truck:'truck' };
    var P = PRESETS[which] || null;
    var con = P ? P.con : (MAP[which] || 'mod');
    gid('bw-vehicle').value = P ? P.vehicle : '2021 BMW M3 Competition — TEST PREFILL';
    var cn=document.querySelector('[name="contact[name]"]'); if(cn) cn.value='Test Build';
    var ce=document.querySelector('[name="contact[email]"]'); if(ce) ce.value='test@example.com';
    var cp=document.querySelector('[name="contact[phone]"]'); if(cp) cp.value='555-555-0100';
    radio('bw_suspension', P?P.suspension:null);
    radio('bw_brakes', P?P.brakes:null);
    setSel('bw-construction', con);
    if(con==='truck') setSel('bw-lug', (P&&P.lug)||'6');
    setSel('bw-series', P?P.series:firstVal('bw-series'));
    setSel('bw-model', P?P.model:firstVal('bw-model'));
    if(vis('bw-blfitfield')) setSel('bw-blfit', (P&&P.blfit)||'full');
    var wantSq = P ? (P.square!==false) : true;
    if(gid('bw-square').checked !== wantSq) gid('bw-square').click();
    setSel('bw-fd', P?P.fd:firstVal('bw-fd'));
    setSel('bw-fw', P?P.fw:firstVal('bw-fw'));
    if(P && P.square===false){ setSel('bw-rd', P.rd); setSel('bw-rw', P.rw); }
    render();
    setSel('bw-center', P?P.center:firstVal('bw-center'));
    if(vis('bw-lipfield')) setSel('bw-lip', (P&&P.lip)||firstVal('bw-lip'));
    if(vis('bw-blfinishfield')) setSel('bw-blfinish', (P&&P.blfinish)||firstVal('bw-blfinish'));
    if(vis('bw-lipstylerow')) setSel('bw-lipstyle', (P&&P.lipstyle)||firstVal('bw-lipstyle'));
    if(vis('bw-hwstylefield')) setSel('bw-hwstyle', (P&&P.hwstyle)||firstVal('bw-hwstyle'));
    if(vis('bw-hardwarerow')) setSel('bw-hardware', (P&&P.hardware)||firstVal('bw-hardware'));
    if(P && P.knurled) chkOn('bw-knurled');
    setSel('bw-cap', P?P.cap:firstVal('bw-cap'));
    setSel('bw-valve', P?P.valve:firstVal('bw-valve'));
    setSel('bw-region', P?P.region:'us');
    render();
    try{ root.querySelector('.ar-bw__build').scrollIntoView({block:'start',behavior:'smooth'}); }catch(e){}
  }
  try{ var _pf=new URLSearchParams(location.search).get('prefill'); if(_pf){ arPrefill(_pf.toLowerCase()); } }catch(e){}

  // QA only: ?inquiry_preview=1 exposes window.__bwInquiry() → returns the exact payload (incl. the
  // branded email HTML) the configurator would POST. Sends nothing anywhere. Pair with ?prefill=.
  try{ if(new URLSearchParams(location.search).get('inquiry_preview')){ window.__bwInquiry=function(){ try{ pack(); }catch(e){} return inquiryPayload(); }; } }catch(e){}
})();
